<template>

  <v-container fluid class="fill-height">
  
    
      <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>
      
    
      <v-dialog v-model="showAlert" max-width="500">
      <v-card>
        <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
        <v-card-text v-html="error_msg">
         
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
          <v-btn class="bg-primary" elevation=1 v-if="showAlertActive" @click="activarSimulacion()">{{$t('general.activar_sim')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <!-- Toolbar -->
       
      <v-toolbar   color="white" class="mb-3">
  
        <v-col cols="4" class="d-flex justify-begin mb-2">
      <v-toolbar-title v-if="!id" >
      
        
        <div class="d-flex align-center" >
          
          <span> <div class="ml-2 mt-0 text-caption gris_suave">{{$t('general.sim')}}</div>{{$t('general.nueva_simulacion')}}</span>
          <v-text-field v-if="!vista_operador"
            v-model="metadata.simulation_name" 
            dense 
            solo
            hide-details
            class="ml-2"
            style="max-width: 500px;"
          ></v-text-field>
        </div>
      </v-toolbar-title>   
      
  
        
      <v-toolbar-title v-else>
        {{$t('general.simulacion_existente')}}
        {{ this.$route.query.created }}
        {{ id }}
        {{ this.$route.query.name || metadata.simulation_name }}
      </v-toolbar-title>
        </v-col>
  
          <v-divider class="mx-4" inset vertical></v-divider>
        <v-col cols="6" v-if="id" class="d-flex align-center">
          {{$t('general.activa')}}:
          <v-checkbox
          :disabled="vista_operador"
              v-model="this.localValid"
              :true-value="1"
              :false-value="0"              
              @change="actualizar_estado(this.id, this.localValid)"
              hide-details
              dense
              color="#94D489"
            ></v-checkbox>
          </v-col>
          <v-spacer></v-spacer>     
  
  
         
   
    
  
          <v-btn v-if="!id && !vista_operador" 
            color="gris_fuerte"         
            @click="guardar_caso_base()"                
          >
            <span class="material-symbols-outlined">save</span>
            {{$t('general.guardar')}}
          </v-btn>
        
          <!-- <v-btn v-if="!id" 
            color="gris_fuerte"         
            @click="obtenerRo()"                
          >
          <span class="material-symbols-outlined">
            directory_sync
            </span>
            obtener RO
          </v-btn> -->
  
          <v-btn v-if="!id" 
            color="gris_fuerte"         
            @click="lanzar_simulacion()"                
          >
          <span class="material-symbols-outlined">rocket_launch</span>     
            {{$t('general.lanzar')}}
          </v-btn>
        
  
      </v-toolbar>
  
     
  <div class="d-flex" style="width: 100%;" v-if="vista_operador">
    
    <!-- Barra de tabs vertical -->
    <v-tabs
      v-model="tab1"
      color="primary"
      direction="vertical"
      show-arrows
      class="elevation-2 gris_medio vertical"
      style="order: 2; "
      slider-color="primary"
    >
      <v-tab value="1" class="tab-hover-azul" ><span class="material-symbols-outlined">bar_chart_4_bars</span>{{$t('tabs.demanda')}}</v-tab>
      <v-tab value="7" class="tab-hover-azul"><span class="material-symbols-outlined">calendar_month</span>{{$t('tabs.disponibilidad')}}</v-tab>
      <v-tab value="3" class="tab-hover-azul" ><span class="material-symbols-outlined">flash_on</span> Precios </v-tab>
     <!-- Acoplamientos en visión operador-->
      <v-tab value="8" class="tab-hover-azul" v-if="configuracion.modoEjecucion === 2 || configuracion.modoEjecucion === 3 || configuracion.modoEjecucion === 4">
        <span class="material-symbols-outlined">join</span> 
        {{$t('tabs.acoplamiento')}}
      </v-tab>
      <v-tab v-if="id!=null" value="9" class="tab-hover-azul" >
      <span class="material-symbols-outlined">area_chart</span>
        {{$t('tabs.resultados')}}</v-tab>
    </v-tabs>
  
    <!-- Contenido de los tabs -->
    <v-tabs-window v-model="tab1" class="flex-grow-1" style="order: 1; ">
  
      <!-- INPUT 
      <v-tabs-window-item value="1">
      </v-tabs-window-item>
      -->
      <!-- DEMANDA -->
      <v-tabs-window-item value="1">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab5"
            color="black"
          class="gris_medio" 
          >
            <v-tab value="1">{{$t('tabs.demanda_vapor')}}</v-tab>
            <v-tab  value="2">{{$t('tabs.demanda_frio')}}</v-tab>
            
            <!-- <v-tab value="1">Demanda</v-tab> -->
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab5">
  
              <v-tabs-window-item value="1">
     
                <ComponenteDemandaVapor
                v-model:demanda_vapor="demanda_vapor"
                v-model:demanda_coef="demanda_coef"
                :horizonte="configuracion.horizonte"
                :fechaActual="configuracion.fechaActual"
                :vista_operador="vista_operador"
                :horizonte_horas="horizonte_horas"
                />
  
              </v-tabs-window-item >
  
              <v-tabs-window-item value="2">
                
                <ComponenteDemandaFrio
                v-model:demanda_frio="demanda_frio" 
                :horizonte="configuracion.horizonte"
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
  
              
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>

 <!-- DISPONIBILIDAD -->
      <v-tabs-window-item value="7">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab6"
           color="black"
          class="gris_medio" 
          >
            <v-tab value="1">{{$t('tabs.disponibilidad_cogeneracion')}}</v-tab>
            <v-tab value="2">{{$t('tabs.disponibilidad_calderas_gas')}}</v-tab>
            <v-tab value="3">{{$t('tabs.disponibilidad_calderas_electricas')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab6">
              <v-tabs-window-item value="1">
                
                <ComponenteDisponibilidadCogeneracion
                  :modelValue="disponibilidad.cogeneracion || []" 
                  @update:modelValue="disponibilidad.cogeneracion = $event"
                  :horizonte="configuracion.horizonte"
                  
                />
                <!-- v-model:modelValue="disponibilidad.cogeneracion" -->
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                
                <ComponenteDisponibilidadCalderaGas
                  :modelValue="disponibilidad.caldera_gas || []" 
                  @update:modelValue="disponibilidad.caldera_gas = $event"
                  :horizonte="configuracion.horizonte"
                  v-model:modelValue="disponibilidad.caldera_gas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3">
                
                <ComponenteDisponibilidadCalderaElectrica
                
                  :modelValue="disponibilidad.caldera_electrica || []" 
                  @update:modelValue="disponibilidad.caldera_electrica = $event"
                  :horizonte="configuracion.horizonte"
                  v-model:modelValue="disponibilidad.caldera_electrica"
                />
              </v-tabs-window-item>            
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>

    <!-- ACOPLAMIENTO visión operador-->
      <v-tabs-window-item value="8">
        <v-container class="pa-0" fluid>
          <ComponenteAcoplamiento
            v-model="acoplamiento_equipos.cogeneracion"
            :estadoAcoplamientoPadre="estadoAcoplamiento"
            :modoEjecucion="configuracion.modoEjecucion"
            @update:modelValue="acoplamiento_equipos.cogeneracion = $event"
            @update:estadoAcoplamiento="actualizarAcoplamiento"
            :horizonte="configuracion.horizonte"
            :opcEjec="configuracion.modoEjecucion"
            :opcEjecTexto="configuracion.modoEjecucion"
          />
        </v-container>
      </v-tabs-window-item>

      <!-- PRECIOS -->
      <v-tabs-window-item value="3">

        <v-row v-show="mostrarBotonesAccesoPrecios">
          <v-col cols="2" class="d-flex justify-begin mb-2">
            <v-btn class="mx-2 gris_medio" @click="solicitarAcceso">
              Solicitar acceso
            </v-btn>
          </v-col>

          <v-col cols="2" class="d-flex justify-begin mb-2">
            <v-btn class="mx-2 gris_medio" @click="accederPrecios">
              Acceder
            </v-btn>
          </v-col>
        </v-row>

        <div v-if="acceso_concedido">
          <v-container class="pa-0" fluid>
            <v-tabs v-model="tab5" color="black" class="gris_medio">
              <v-tab value="1">Electricidad</v-tab>
              <v-tab value="2">Gas</v-tab>
            </v-tabs>

            <v-card-text>
              <v-tabs-window v-model="tab5">

                <v-tabs-window-item value="1">
                  <ComponenteElecPreciosManual
                    :elec_manual="elec_precios_manual"
                    :horizonte="configuracion.horizonte"
                    :fecha="configuracion.fechaActual"
                    :horizonte_horas="horizonte_horas"
                  />
                </v-tabs-window-item>

                <v-tabs-window-item value="2">
                  <ComponenteGasPreciosManual
                    v-model:gas_manual="gas_precios_manual"
                    :horizonte="configuracion.horizonte"
                    :fecha="configuracion.fechaActual"
                    :horizonte_horas="horizonte_horas"
                  />
                </v-tabs-window-item>

              </v-tabs-window>
            </v-card-text>
          </v-container>
        </div>

      </v-tabs-window-item>


  
      <!-- RESULTADOS -->
      <v-tabs-window-item value="9" v-if="id!=null">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab7"
            color="black"
          class="gris_medio" 
          >
            <v-tab value="1">{{$t('tabs.resultados_prevision_operarios')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab7">
              <v-tabs-window-item value="1">
                <!--
                <ComponenteProgramaResultado
                v-model:items="programa"
                />  
                -->            
                <ComponentePrograma
                :items="programa"
                :fechaActual="configuracion.fechaActual"
                :modoEjecucion="configuracion.modoEjecucion"
                ref="componentePrograma"
                @descargar-excel="exportarExcelCompleto"
                :vista_operador="vista_operador"
                :precios_omie="elec_precios_OMIE"
                :precios_omie_qh="elec_precios_OMIE_QH"
                :precio-pool-referencia="precioPoolReferencia"
                :precio-pool-referencia-ce="precioPoolReferenciaCe"
                :parametrosGas="gas_parametros"
                :otros="configuracion.otros"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                <ComponenteResultadosOper
                v-model:items="resultados"
                ref="componenteResultadosOper"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3" :eager="true">
                <ComponenteResultadosEcon
                v-model:items="resultados"
                ref="componenteResultadosEcon"
                @precio-pool-ref="precioPoolReferencia = $event"
                @precio-pool-ref-ce="precioPoolReferenciaCe = $event"
                />
              </v-tabs-window-item>            
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>

  <div class="d-flex justify-end" style="width: 100%;" v-if="!vista_operador">
  
    <!-- Barra de tabs vertical -->
    <v-tabs vertical
      v-model="tab1"
      
      direction="vertical"
      show-arrows
      color="primary"
      class="elevation-2 gris_medio vertical"
      slider-color="primary"
      style="order: 2; "
    >
      <v-tab value="1" class="tab-hover-azul" ><span class="material-symbols-outlined">tune</span>   {{$t('tabs.generales')}}</v-tab>
      <v-tab value="2" class="tab-hover-azul" ><span class="material-symbols-outlined">factory</span> {{$t('tabs.planta')}}</v-tab>
      <v-tab value="3" class="tab-hover-azul" ><span class="material-symbols-outlined">flash_on</span> {{$t('tabs.electricidad')}}</v-tab>
      <v-tab value="4" class="tab-hover-azul" ><span class="material-symbols-outlined">mode_heat</span> {{$t('tabs.gas')}}</v-tab>
      <v-tab value="5" class="tab-hover-azul" ><span class="material-symbols-outlined">euro</span> {{$t('tabs.ro_cogeneracion')}}</v-tab>
      <v-tab value="6" class="tab-hover-azul" ><span class="material-symbols-outlined">bar_chart_4_bars</span> {{$t('tabs.demanda')}}</v-tab>
      <v-tab value="7" class="tab-hover-azul" ><span class="material-symbols-outlined">calendar_month</span> {{$t('tabs.disponibilidad')}}</v-tab>
      <v-tab value="8" class="tab-hover-azul" v-if="configuracion.modoEjecucion === 2 || configuracion.modoEjecucion === 3 || configuracion.modoEjecucion === 4">
        <span class="material-symbols-outlined">join</span> 
        {{$t('tabs.acoplamiento')}}
      </v-tab>
      <v-tab v-if="id!=null" value="9">
        <span class="material-symbols-outlined">area_chart</span>
        {{$t('tabs.resultados')}}</v-tab>
        <!-- NUEVO: tab Backup SIEMPRE visible -->
      <v-tab value="10" class="tab-hover-azul">
        <span class="material-symbols-outlined">backup</span>
        {{$t('tabs.backup')}}
      </v-tab>
    </v-tabs>
    <!-- Aqui se coloca la parte que se mantiene entre todos los tabs -->
 
    <!-- Contenido de los tabs -->
    <v-tabs-window v-model="tab1" class="flex-grow-1" style="order: 1;">
  
      <!-- CONFIGURACIÓN -->
      <v-tabs-window-item value="1">
        <v-container class="pa-0" fluid >
          <v-tabs
          v-model="tab2"
          color="black"
          class="gris_medio"  
         
          >
          <v-tab value="1"><span class="material-symbols-outlined">settings</span> {{$t('tabs.configuracion')}}</v-tab>
          <v-tab value="2"><span class="material-symbols-outlined">work</span> {{$t('tabs.otros')}}</v-tab>
        </v-tabs>
        <v-card-text>
                
                <v-tabs-window v-model="tab2">              
                  <v-tabs-window-item value="1">
                    <!-- Contenido de Configuración -->
                    <ComponenteConfiguracion
                    ref="ComponenteConf"
                    :modelValue="configuracion"
                    @update:modelValue="configuracion = $event" 
                    @fecha-cambiada="accionEnCambioFecha"
                    @horizonte-cambiado="accionEnCambioHorizonte"
                    @precio-cambiado="accionEnCambioPrecio"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="2">
                    <ComponenteOtrosDatos 
                    :precioCO2="configuracion.otros.precio_CO2"
                    @update:precioCO2="configuracion.otros.precio_CO2 = Number($event)"

                    :precioElectricidadCerrado="configuracion.otros.precio_electricidad_cerrado"
                    @update:precioElectricidadCerrado="configuracion.otros.precio_electricidad_cerrado = Number($event)"

                    :potenciaElectricidadCerrado="configuracion.otros.potencia_precio_electricidad_cerrado"
                    @update:potenciaElectricidadCerrado="configuracion.otros.potencia_precio_electricidad_cerrado = Number($event)"

                    :impuestoGeneracion="configuracion.otros.impuesto_generacion"
                    @update:impuestoGeneracion="configuracion.otros.impuesto_generacion = Number($event)"

                    :minTecnico="configuracion.otros.min_tecnico_secundaria ?? 28"
                    @update:minTecnico="configuracion.otros.min_tecnico_secundaria = Number($event)"

                    :cantidadMin="configuracion.otros.cantidad_min_secundaria ?? 16"
                    @update:cantidadMin="configuracion.otros.cantidad_min_secundaria = Number($event)"

                    :cantidadMax="configuracion.otros.cantidad_max_secundaria ?? 47.4"
                    @update:cantidadMax="configuracion.otros.cantidad_max_secundaria = Number($event)"

                    :oferta="configuracion.otros.coste_operativo_secundaria ?? 95"
                    @update:oferta="configuracion.otros.coste_operativo_secundaria = Number($event)"
                  />
                  </v-tabs-window-item>
                </v-tabs-window>
  
              </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
      <!-- PLANTA -->
      <v-tabs-window-item value="2">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab2"
           
            color="black"
            class="gris_suave"
          >
            <v-tab value="1">{{$t('tabs.planta_motores_cogeneracion')}}</v-tab>
            <v-tab value="2">{{$t('tabs.planta_calderas_gas')}}</v-tab>
            <v-tab value="3">{{$t('tabs.planta_calderas_electricas')}}</v-tab>
            <v-tab value="4">{{$t('tabs.planta_compresor')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab2">
              <v-tabs-window-item value="1">
                <!-- Contenido Motores Cogeneración -->
                <ComponenteMotoresCogeneracion
                v-model="planta.planta_motores_cogeneracion"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                <!-- Contenido Calderas Gas -->
                <ComponenteCalderasGas
                v-model="planta.planta_calderas_gas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3">
                <!-- Contenido Calderas Eléctricas -->
                <ComponenteCalderasElectricas
                v-model="planta.planta_calderas_electricas" 
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="4">
                <!-- Contenido Compresor -->
                <ComponenteCompresor
                v-model="planta.planta_compresores"
                />
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
      <!-- ELECTRICIDAD -->
      <v-tabs-window-item value="3">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab3"
           
            color="black"
            class="gris_suave"
          >
            <v-tab value="1">{{$t('tabs.electricidad_peajes')}}</v-tab>
            <v-tab value="2">{{$t('tabs.electricidad_swap')}}</v-tab>
            <v-tab value="3" v-if="configuracion.pestanas.omie">{{$t('tabs.electricidad_precios_omie')}}</v-tab>
            <v-tab value="4" v-if="configuracion.pestanas.previsión">{{$t('tabs.electricidad_precios_prevision')}}</v-tab>
            <v-tab value="5" v-if="configuracion.pestanas.manualElect">{{$t('tabs.electricidad_precios_manual')}}</v-tab>
            <v-tab value="6" v-if="configuracion.pestanas.ElecPreciosHistoricos">{{ $t('tabs.electricidad_precios_historicos') }}</v-tab>
            <v-tab value="7" v-if="configuracion.pestanas.ElecPrevisionPrecios">{{ $t('tabs.electricidad_precios_manual') }}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab3">
              <v-tabs-window-item value="1">
                <!-- Contenido Peajes -->
                <ComponenteElecPeajes  
                v-model:elec_peajes="elec_peajes"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                <!-- Contenido Precios Manual -->
                <ComponenteElecSwap
                v-model:elec_swap="elec_swap" 
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3">
                <!-- Contenido Precios OMIE -->
                <ComponenteElecPreciosOMIE 
                v-if="configuracion.modoEjecucionTexto !== 'Backtesting'"
                :precios_omie="elec_precios_OMIE"
                :horizonte="configuracion.horizonte"
                :horizonte_horas="horizonte_horas"
                 />
              </v-tabs-window-item>
              <v-tabs-window-item value="4">
                <!-- Contenido Previsión Precios -->
                <ComponenteElecPreciosPrevision
                :elec_prevision="elec_precios_prevision"
                :horizonte="configuracion.horizonte"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="5">
                <!-- Contenido Precios Manual -->
                <ComponenteElecPreciosManual
                :elec_manual="elec_precios_manual" 
                :horizonte="configuracion.horizonte"
                :fecha="configuracion.fechaActual"
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="6">
                <ComponenteElecPreciosHistoricos 
                v-if="configuracion.modoEjecucionTexto === 'Backtesting'"
                :precios_omie="elec_precios_OMIE"
                @descargar-precios-omie="descargar_precios_omie" 
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="7">
                <ComponenteElecPreciosPlanificacion
                :horizonte="configuracion.horizonte"
                v-model:elec_precios_manual="elec_precios_manual"
                 />
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
      <!-- GAS -->
      <v-tabs-window-item value="4">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab4"
            
            color="black"
            class="gris_suave"
          >
          <v-tab value="1"> {{ $t('tabs.gas_parametros') }}</v-tab>
          <v-tab value="2"> {{ $t('tabs.gas_swap') }}</v-tab>
            <v-tab value="3" v-if="configuracion.pestanas.mibgas">{{$t('tabs.gas_precios_mibgas')}}</v-tab>
            <v-tab value="4" v-if="configuracion.pestanas.manualGas">{{$t('tabs.gas_precios_manual')}}</v-tab>
            <v-tab value="5" v-if="configuracion.pestanas.GasPreciosHistoricos">{{ $t('tabs.gas_precios_historicos') }}</v-tab>
            <v-tab value="6" v-if="configuracion.pestanas.GasPrevisionPrecios">{{ $t('tabs.gas_precios_manual') }}</v-tab>
           
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab4">
              <v-tabs-window-item value="1">
                <!-- Contenido Precios MIBGAS -->
                <ComponenteGasParametros 
                v-model:gas_parametros="gas_parametros"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
              <ComponenteGasSwap 
              v-model:gas_swap ="gas_swap"
              />
            </v-tabs-window-item>
              <v-tabs-window-item value="3">
                <!-- Contenido Precios MIBGAS -->
                <ComponenteGasPreciosMibgas 
                
                v-model:gas_mibgas="gas_precios_MIBGAS"
                :horizonte="configuracion.horizonte"
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="4">
                <!-- Contenido Precios Manual -->
                <ComponenteGasPreciosManual
                v-model:gas_manual="gas_precios_manual"
                :horizonte="configuracion.horizonte"
                :fecha="configuracion.fechaActual"
                :horizonte_horas="horizonte_horas"
                 />
              </v-tabs-window-item>
              <v-tabs-window-item value="5">
                <ComponenteGasPreciosHistoricos 
                 v-if="configuracion.modoEjecucionTexto === 'Backtesting'"
                :gas_mibgas="gas_precios_MIBGAS"
                @descargar-precios-mibgas="descargar_precios_mibgas" 
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="6">
                <ComponenteGasPreciosPlanificacion 
                v-model:gas_precios_manual="gas_precios_manual" 
                :horizonte="configuracion.horizonte"
                />
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
      <!-- RO COGENERACIÓN -->
      <v-tabs-window-item value="5">
        <v-container class="pa-0" fluid>
          <ComponenteRoCogeneracion
          v-model="ro_cogeneracion"
          :mesesUnicos="meses_unicos"
          :horizonte="configuracion.horizonte"
          @generar-datos-ro="generarDatosRoCogeneracion"
          />
        </v-container>
      </v-tabs-window-item>
  
      <!-- DEMANDA -->
      <v-tabs-window-item value="6">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab5"
            
            color="black"
            class="gris_suave"
          >
            <v-tab value="1">{{$t('tabs.demanda_vapor')}}</v-tab>
            <v-tab value="2">{{$t('tabs.demanda_frio')}}</v-tab>
            
            <!-- <v-tab value="1">Demanda</v-tab> -->
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab5">
  
              <v-tabs-window-item value="1">
                
                <ComponenteDemandaVapor
                v-model:demanda_vapor="demanda_vapor"
                v-model:demanda_coef="demanda_coef"
                :horizonte="configuracion.horizonte"
                :fechaActual="configuracion.fechaActual"
                :horizonte_horas="horizonte_horas"
                />
  
              </v-tabs-window-item >
  
              <v-tabs-window-item value="2">
                
                <ComponenteDemandaFrio
                v-model:demanda_frio="demanda_frio" 
                :horizonte="configuracion.horizonte"
                :horizonte_horas="horizonte_horas"
                />
              </v-tabs-window-item>
  
              
  
              <!-- <v-tabs-window-item value="1">
                <ComponenteDemanda  
                v-model:demanda_vapor="demanda_vapor"
                v-model:demanda_coef="demanda_coef"
                :horizonte="configuracion.horizonte"
                :fechaActual="configuracion.fechaActual"
                v-model:demanda_frio="demanda_frio" 
                />
                 
              </v-tabs-window-item> -->
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
  
      <!-- DISPONIBILIDAD -->
      <v-tabs-window-item value="7">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab6"
           
            color="black"
            class="gris_suave"
          >
            <v-tab value="1">{{$t('tabs.disponibilidad_cogeneracion')}}</v-tab>
            <v-tab value="2">{{$t('tabs.disponibilidad_calderas_gas')}}</v-tab>
            <v-tab value="3">{{$t('tabs.disponibilidad_calderas_electricas')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab6">
              <v-tabs-window-item value="1">
                
                <ComponenteDisponibilidadCogeneracion
                  :modelValue="disponibilidad.cogeneracion || []" 
                  @update:modelValue="disponibilidad.cogeneracion = $event"
                  :horizonte="configuracion.horizonte"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                
                <ComponenteDisponibilidadCalderaGas
                  :modelValue="disponibilidad.caldera_gas || []" 
                  @update:modelValue="disponibilidad.caldera_gas = $event"
                  :horizonte="configuracion.horizonte"
                  v-model:modelValue="disponibilidad.caldera_gas"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3">
                
                <ComponenteDisponibilidadCalderaElectrica
                
                  :modelValue="disponibilidad.caldera_electrica || []" 
                  @update:modelValue="disponibilidad.caldera_electrica = $event"
                  :horizonte="configuracion.horizonte"
                  v-model:modelValue="disponibilidad.caldera_electrica"
                />
              </v-tabs-window-item>            
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
  
  
      <!-- ACOPLAMIENTO -->
      <v-tabs-window-item value="8">
        <v-container class="pa-0" fluid>
          <!-- Contenido acoplamiento -->
          <ComponenteAcoplamiento
            v-model="acoplamiento_equipos.cogeneracion"
            :estadoAcoplamientoPadre="estadoAcoplamiento"
            :modoEjecucion="configuracion.modoEjecucion"
            @update:modelValue="acoplamiento_equipos.cogeneracion = $event"
            @update:estadoAcoplamiento="actualizarAcoplamiento"
            :horizonte="configuracion.horizonte"
            :opcEjec="configuracion.modoEjecucion"
            :opcEjecTexto="configuracion.modoEjecucion"
          />
        </v-container>
      </v-tabs-window-item>
  
  
      <!-- RESULTADOS -->
      <v-tabs-window-item value="9" v-if="id!=null">
        <v-container class="pa-0" fluid>
          <v-tabs
            v-model="tab7"
          
            color="black"
            class="gris_suave"
          >
            <v-tab value="1">{{$t('tabs.resultados_prevision_operarios')}}</v-tab>
            <v-tab value="2">{{$t('tabs.resultados_oper')}}</v-tab>
            <v-tab value="3">{{$t('tabs.resultados_econ')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab7">
              <v-tabs-window-item value="1" :eager="true">
                <!--
                <ComponenteProgramaResultado
                v-model:items="programa"
                />  
                -->            
                <ComponentePrograma
                :items="programa"
                :fechaActual="configuracion.fechaActual"
                ref="componentePrograma"
                @descargar-excel="exportarExcelCompleto"
                :modoEjecucion="configuracion.modoEjecucion"
                :precios_omie="elec_precios_OMIE"
                :precios_omie_qh="elec_precios_OMIE_QH"
                :precio-pool-referencia="precioPoolReferencia"
                :precio-pool-referencia-ce="precioPoolReferenciaCe"
                :parametrosGas="gas_parametros"
                :otros="configuracion.otros"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2" :eager="true">
                <ComponenteResultadosOper
                v-model:items="resultados"
                ref="componenteResultadosOper"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="3" :eager="true">
                <ComponenteResultadosEcon
                v-model:items="resultados"
                ref="componenteResultadosEcon"
                @precio-pool-ref="precioPoolReferencia = $event"
                @precio-pool-ref-ce="precioPoolReferenciaCe = $event"
                />
              </v-tabs-window-item>            
            </v-tabs-window>
          </v-card-text>
        </v-container>
      </v-tabs-window-item>
      <!-- NUEVO: BACKUP -->
      <v-tabs-window-item value="10">
        <v-container class="pa-0" fluid>
          <ComponenteBackup
            :vista-operador="vista_operador"
            :id="id"
            :mostrar-boton-descargar-in="mostrar_boton_descargar_in"
            @importar="importData"
            @exportar="exportData"
            @descargar-in="descargar_in"
          />
        </v-container>
      </v-tabs-window-item>
  
  
  
  
    </v-tabs-window>
  
  </div>
  
  
  
  
  <br>
  <!--<div class="footer-buttons d-flex justify-end w-100 py-2 mt-auto">
    <v-btn
      
      class="ma-2"
      @click="importData"
      v-if="!vista_operador && !id"
    >
      <span class="material-symbols-outlined">file_open</span>
      {{$t('general.importar')}}
    </v-btn>

    <v-btn
      
      class="ma-2"
      @click="exportData"
      v-if="!vista_operador"
    >
      <span class="material-symbols-outlined">file_save</span>
      {{$t('general.exportar')}}
    </v-btn>

    <v-btn
      
      class="ma-2"
      @click="descargar_in"
      v-if="!id && mostrar_boton_descargar_in"
    >
      <span class="material-symbols-outlined">download</span>
      {{$t('general.descargar_input')}}
    </v-btn>
  </div>-->
  
    
  </v-container>
  </template>
  
  
  
  
  <script>
  import ComponenteConfiguracion from '../components/configuracion/ComponenteConfiguracion.vue';
  import ComponenteOtrosDatos from '../components/configuracion/ComponenteOtrosDatos.vue';
  
  
  //import ComponenteDemanda from '../components/demanda/ComponenteDemanda.vue'
  import ComponenteDemandaFrio from '../components/demanda/ComponenteDemandaFrio.vue'
  import ComponenteDemandaVapor from '../components/demanda/ComponenteDemandaVapor.vue'
  
  import ComponenteElecPeajes from '../components/electricidad/ComponenteElecPeajes.vue';
  import ComponenteElecPreciosManual from '../components/electricidad/ComponenteElecPreciosManual.vue';
  import ComponenteElecPreciosOMIE from '../components/electricidad/ComponenteElecPreciosOMIE.vue';
  import ComponenteElecPreciosPrevision from '../components/electricidad/ComponenteElecPreciosPrevision.vue';
  import ComponenteElecSwap from '../components/electricidad/ComponenteElecSwap.vue';
  import ComponenteElecPreciosHistoricos from '../components/electricidad/ComponenteElecPreciosHistoricos.vue';
  import ComponenteElecPreciosPlanificacion from './electricidad/ComponenteElecPreciosPlanificacion.vue';
  
  import ComponenteGasPreciosManual from '../components/gas/ComponenteGasPreciosManual.vue';
  import ComponenteGasPreciosMibgas from '../components/gas/ComponenteGasPreciosMibgas.vue';
  import ComponenteGasParametros from '../components/gas/ComponenteGasParametros.vue';
  import ComponenteGasSwap from '../components/gas/ComponenteGasSwap.vue';
  import ComponenteGasPreciosHistoricos from '../components/gas/ComponenteGasPreciosHistoricos.vue';
  import ComponenteGasPreciosPlanificacion from './gas/ComponenteGasPreciosPlanificacion.vue';
  
  import ComponenteCalderasElectricas from '../components/planta/ComponenteCalderasElectricas.vue';
  import ComponenteCalderasGas from '../components/planta/ComponenteCalderasGas.vue';
  import ComponenteMotoresCogeneracion from '../components/planta/ComponenteMotoresCogeneracion.vue';
  import ComponenteCompresor from '../components/planta/ComponenteCompresor.vue';
  
  import ComponenteDisponibilidadCogeneracion from '../components/disponibilidad/ComponenteDisponibilidadCogeneracion.vue';
  import ComponenteDisponibilidadCalderaElectrica from '../components/disponibilidad/ComponenteDisponibilidadCalderaElectrica.vue';
  import ComponenteDisponibilidadCalderaGas from '../components/disponibilidad/ComponenteDisponibilidadCalderaGas.vue';
  
  import ComponenteAcoplamiento from '../components/acoplamiento/ComponenteAcoplamiento.vue';
  
  import ComponentePrograma from '../components/resultados/ComponentePrograma.vue';
  import ComponenteResultadosEcon from '../components/resultados/ComponenteResultadosEcon.vue';
  import ComponenteResultadosOper from '../components/resultados/ComponenteResultadosOper.vue';
  
  import ComponenteRoCogeneracion from '../components/Ro-cogeneracion/ComponenteRoCogeneracion.vue';
  
  import ComponenteLoading from '../components/ComponenteLoading.vue';
  import ComponenteBackup from '../components/ComponenteBackup.vue';
  
  import JSZip from 'jszip';
  import axios from 'axios';
  import store from '../store';
  import Swal from "sweetalert2";
  import lottie from "lottie-web";
  import ExcelJS from 'exceljs';
  import { saveAs } from 'file-saver';
  
  //import * as yup from "yup";
  //import { Structs } from 'phaser';

  // Devuelve true si el momento actual está en horario laboral (L-V, 12:00-18:00)
  function esHorarioLaboral() {
    const ahora = new Date();
    const diaSemana = ahora.getDay(); // 0=domingo, 6=sábado
    const hora = ahora.getHours();
    return diaSemana >= 1 && diaSemana <= 5 && hora >= 12 && hora < 18;
  }

  export default {
    props: {
        id: {
          type: String,
          default: null
        },
        valid:{
          type: String,
          default:null
        },
        created:{
          type:String,
          default:null
        }
      },
    components: {    
        ComponenteConfiguracion,
        //ComponenteDemanda,
        ComponenteDemandaFrio,
        ComponenteDemandaVapor,
        ComponenteOtrosDatos,
        ComponenteElecPeajes,
        ComponenteElecPreciosManual,
        ComponenteElecPreciosOMIE,
        ComponenteElecPreciosPrevision,
        ComponenteElecSwap,
        ComponenteElecPreciosHistoricos,
        ComponenteElecPreciosPlanificacion,
        ComponenteGasPreciosManual,
        ComponenteGasPreciosMibgas,
        ComponenteGasParametros,
        ComponenteGasSwap,
        ComponenteGasPreciosHistoricos,
        ComponenteGasPreciosPlanificacion,
        ComponenteCalderasGas,      
        ComponenteCalderasElectricas,
        ComponenteMotoresCogeneracion,
        ComponenteCompresor,
        ComponentePrograma,
        ComponenteResultadosEcon,
        ComponenteResultadosOper,
        ComponenteDisponibilidadCogeneracion,
        ComponenteDisponibilidadCalderaElectrica,
        ComponenteDisponibilidadCalderaGas,
        ComponenteAcoplamiento,
        ComponenteRoCogeneracion,
        ComponenteLoading,      
        ComponenteBackup,
        },
    data() {
      //const enHorarioLaboral = esHorarioLaboral();
      return {
        precioPoolReferencia: null,
        precioPoolReferenciaCe:null,
        usuario: store.state.usuarioNombre,
        lista_simulaciones: Array.isArray(store.state.listaSimulations)
          ? store.state.listaSimulations
          : [],

        listaSimulacionesCargada: Array.isArray(store.state.listaSimulations)
          && store.state.listaSimulations.length > 0,

        localValid:parseInt(this.$route.query.valid),
        loading: false,
        mensaje_loading: "",
        showAlert:false,
        showAlertActive:false,
        error_msg:"",
        deshabilitar_generacion:0,
        horizonte_horas:24,
        tab1: "1", // Tab principal
        tab2: "1", // tab secundario
        tab3: "1",
        tab4: "1",
        tab5: "1",
        tab6: "1",
        tab7: "1",
        disponibilidadAnterior: [],
  
  
        //------------------------------------------------------------------
        // Estructura de datos de negocio
        // A partir de estos datos se crean los ficheros .dat en el backend
        //------------------------------------------------------------------
        // Nuevos datos planificación y backtesting
        //elec_precios_historicos: [],
        //elec_precios_planificacion: [],
        //gas_precios_historicos: [],
        //gas_precios_planificacion: [],
        //Estructura de datos para electricidad
        elec_peajes:[
          // Pot.contratada calderas eléctricas (MWe)
          
        { periodo: "p1",pot_contratada_calderas:0.00 ,pot_contratada: 0.00,pcio_exceso_potencia:0.00, pot_elec_precio_cerrado:0.00, peaje_pot: 4.892, ai_omie_abierto: 1.072, bi_omie_abierto: 18.376, ai_fijo_cerrado: 1.313, bi_fijo_cerrado: 18.38 },
                      { periodo: "p2", pot_contratada_calderas:7.00 ,pot_contratada: 0.00,pcio_exceso_potencia:0.00, pot_elec_precio_cerrado:1.37, peaje_pot: 2.884, ai_omie_abierto: 1.073, bi_omie_abierto: 15.322, ai_fijo_cerrado: 1.242, bi_fijo_cerrado: 15.32 },
                      { periodo: "p3", pot_contratada_calderas:20.00 ,pot_contratada: 18.50,pcio_exceso_potencia:0.00, pot_elec_precio_cerrado:2.22, peaje_pot: 1.947, ai_omie_abierto: 1.062016, bi_omie_abierto: 13.1022, ai_fijo_cerrado: 1.06, bi_fijo_cerrado: 13.10 },
                      { periodo: "p4", pot_contratada_calderas:20.00 ,pot_contratada: 32.10,pcio_exceso_potencia:0.00, pot_elec_precio_cerrado:2.22, peaje_pot: 1.758, ai_omie_abierto: 1.063, bi_omie_abierto: 11.4278, ai_fijo_cerrado: 1.051, bi_fijo_cerrado: 11.43 },
                      { periodo: "p5", pot_contratada_calderas:20.00 ,pot_contratada: 32.10,pcio_exceso_potencia:17.40, pot_elec_precio_cerrado:2.22, peaje_pot: 0.871, ai_omie_abierto: 1.052, bi_omie_abierto: 10.306, ai_fijo_cerrado: 1.013, bi_fijo_cerrado: 10.31 },
                      { periodo: "p6", pot_contratada_calderas:20.00 ,pot_contratada: 32.10,pcio_exceso_potencia:17.40, pot_elec_precio_cerrado:2.22, peaje_pot: 0.425, ai_omie_abierto: 1.074, bi_omie_abierto: 9.771, ai_fijo_cerrado: 1.008, bi_fijo_cerrado: 9.77 }
      ],

        elec_precios_manual: [117.02, 113.14, 112.38, 112.64, 112.58, 112.88, 116.84, 120.72, 116.84, 112.82,111.92, 98.00, 92.98, 92.79, 88.99, 83.00, 81.80, 81.80, 94.37, 109.20, 117.60,
    132.66, 125.50, 117.14, 14.56, 10.94, 10.00, 7.80, 8.00, 10.94, 22.90, 35.01, 35.00,10.94, 3.25, 2.49, 1.79, 1.83, 0.00, 0.44, 1.06, 0.44, 5.39, 17.60, 35.40, 59.14,
    43.90, 35.64, 35.01, 35.01, 35.00, 35.00, 35.00, 34.43, 35.00, 41.00, 35.00, 28.90,16.20, 4.99, 6.10, 5.00, 3.25, 2.51, 0.44, 3.25, 9.08, 27.94, 40.00, 66.52, 50.02,
    42.00, 35.00, 33.11, 27.94, 18.90, 16.20, 18.90, 22.23, 26.22, 16.20, 2.10, 0.01,0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 3.25, 30.00, 35.01, 35.02, 35.01,
    30.00, 26.87, 24.13, 22.62, 22.86, 24.81, 26.87, 25.63, 16.72, 3.25, 1.88, 0.44,0.00, -0.04, -0.58, -0.10, 0.00, 0.00, 3.25, 6.10, 29.90, 54.33, 51.61, 50.15, 63.58,
    55.99, 51.91, 53.96, 51.08, 53.96, 57.10, 84.03, 86.89, 61.54, 45.13, 35.00, 18.90,10.00, 6.10, 4.99, 4.23, 5.00, 9.90, 37.62, 75.10, 97.69, 93.20, 84.42, 81.73, 77.64,
    74.77, 68.24, 66.82, 69.09, 75.98, 99.87, 75.62, 35.00, 10.00, 3.60, 0.00, 0.00, 0.00,0.00, 0.00, 0.00, 0.00, 35.00, 56.18, 67.44, 62.00, 50.01],
        /* elec_precios_OMIE:[4.89, 2.88, 1.95, 1.76, 0.87, 0.43, 4.80, 3.60, 2.30, 1.10, 
                          0.99, 0.78, 0.65, 0.57, 0.60, 0.80, 1.05, 1.20, 1.30, 1.50,
                          1.60, 1.70, 1.90, 2.00], */  // Ejemplo de precios de 24 horas del día
        elec_precios_OMIE:[],
        elec_precios_OMIE_QH:[],
        elec_precios_prevision:[117.01, 113.02, 109.87, 107.67, 107.27, 110.54, 119.73, 128.38, 133.07, 128.01,
                     117.48, 111.85, 109.64, 108.88, 107.75, 107.71, 112.59, 122.79, 133.34, 141.68,
                     140.40, 135.95, 129.00, 121.50],
        elec_swap:[
               {
                id:"swap1",
                cantidad: 16.00,
                precio: 84.75
              },
               {
                id:"swap2",
                cantidad: 0.00,
                precio: 0.00
              },
               {
                id:"swap3",
                cantidad: 0.00,
                precio: 0.00
              }
            ],
        demanda_vapor: [
              60.948, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512,
              62.078, 62.644, 62.644, 62.644, 63.766, 63.207, 62.644, 61.512,
              61.512, 62.644, 63.207, 63.766, 64.316, 64.857, 65.385, 65.385
            ],
        demanda_frio:[2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50,
                      2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50,
                      2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50],
        demanda_coef:1.00,
  
  
        configuracion: {
  
  
        fechaActual: new Date().toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
        otros: {
          precio_CO2: 70.00,
          precio_electricidad_cerrado: 73,
          potencia_precio_electricidad_cerrado: 3.7,
          impuesto_generacion: 0.07,
          min_tecnico: 28,
          cantidad_min: 16,
          cantidad_max: 47.4,
          coste_operativo: 95
            
        },
  
          precios: 'OMIE', //Valor por defecto
          opciones_precios: {
            omie: "OMIE",
            simulart: "SimularT",
            manual: "Manual"
          },
          horizonte: 1,
          modoEjecucion: 2,
          //modoEjecucionTexto:"Acoplamientos de cogeneración fijados",
          //mesBacktesting: "07/2024",
          //mesPlanificacion: "07/2024",
          //mesHabilitado: false,
          pestanas: { 
            previsión: false,
            omie: false,
            manualElect: false,
            mibgas: false,
            manualGas: false,
            ElecPreciosHistoricos: false,
            ElecPrevisionPrecios: false,
            GasPreciosHistoricos: false,
            GasPrevisionPrecios: false,
          }
          
        },
  
        disponibilidad: {  // Asegura que disponibilidad está inicializado correctamente
          caldera_electrica: [],
          caldera_gas: [],
          cogeneracion: []
  
        },
  
        acoplamiento_equipos: {
        cogeneracion: []
        },
        
        estadoAcoplamiento: ["No", "No", "No", "No", "Si", "No", "Si", "No"],
        
  
        "metadata": {
          "id": 1,
          "simulation_name": "Sin título",
         
        },
        "planta": {
          "planta_calderas_electricas": [
            {
              "nombre": "Caldera eléctrica 1",
              "potencia_electrica_maxima": 20.0,
              "potencia_electrica_minima": 0, //56.0
              "potencia_vapor_maximo": 19.8,
              "rendimiento_vapor_electricidad": 0.99,
              "estado_inicial_equipo": "Parado"
            },
            {
              "nombre": "Caldera eléctrica 2",
              "potencia_electrica_maxima": 0.0,
              "potencia_electrica_minima": 0.0,
              "potencia_vapor_maximo": 0.0,
              "rendimiento_vapor_electricidad": 0.99,
              "estado_inicial_equipo": "Parado"
            }
          ],
          "planta_motores_cogeneracion": [
            {
              "nombre": "Motor cogeneración 1",
              "potencia_maxima": 3.33,
              "potencia_minima": 3.33,
              "potencia_exportacion": 3.247,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.407,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.21,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 15,
              "tiempo_parada": 15,
              "estado": "Encendido",
              "fee": 7.103,
              "tiempo_minimo_acoplamiento": 3,
              "tiempo_minimo_parada": 2
            },
            {
              "nombre": "Motor cogeneración 2",
              "potencia_maxima": 3.33,
              "potencia_minima": 3.33,
              "potencia_exportacion": 3.247,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.402,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.21,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 15,
              "tiempo_parada": 15,
              "estado": "Encendido",
              "fee": 7.103,
              "tiempo_minimo_acoplamiento": 3,
              "tiempo_minimo_parada": 2
            },
            {
              "nombre": "Motor cogeneración 3",
              "potencia_maxima": 3.33,
              "potencia_minima": 3.33,
              "potencia_exportacion": 3.247,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.395,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.21,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 15,
              "tiempo_parada": 15,
              "estado": "Encendido",
              "fee": 7.103,
              "tiempo_minimo_acoplamiento": 3,
              "tiempo_minimo_parada": 2
            },
            {
              "nombre": "Motor cogeneración 4",
              "potencia_maxima": 5.076,
              "potencia_minima": 5.076,
              "potencia_exportacion": 4.927,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.401,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.21,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 20,
              "tiempo_parada": 20,
              "estado": "Encendido",
              "fee": 8.59,
              "tiempo_minimo_acoplamiento": 3,
              "tiempo_minimo_parada": 2
            },
            {
              "nombre": "Motor cogeneración 5",
              "potencia_maxima": 8.43,
              "potencia_minima": 8.43,
              "potencia_exportacion": 8.00,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.393,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.67,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 30,
              "tiempo_parada": 30,
              "estado": "Encendido",
              "fee": 7.316,
              "tiempo_minimo_acoplamiento": 4,
              "tiempo_minimo_parada": 3
            },
            {
              "nombre": "Motor cogeneración 6",
              "potencia_maxima": 8.43,
              "potencia_minima": 8.43,
              "potencia_exportacion": 8.267,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.398,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.67,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 60,
              "tiempo_parada": 30,
              "estado": "Encendido",
              "fee": 7.316,
              "tiempo_minimo_acoplamiento": 4,
              "tiempo_minimo_parada": 3
            },
            {
              "nombre": "Motor cogeneración 7",
              "potencia_maxima": 8.43,
              "potencia_minima": 8.43,
              "potencia_exportacion": 8.00,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.402,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.67,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 30,
              "tiempo_parada": 30,
              "estado": "Encendido",
              "fee": 7.316,
              "tiempo_minimo_acoplamiento": 4,
              "tiempo_minimo_parada": 3
            },
            {
              "nombre": "Motor cogeneración 8",
              "potencia_maxima": 8.43,
              "potencia_minima": 8.43,
              "potencia_exportacion": 8.267,
              "rendimiento_vapor_gas": 0.27,
              "rendimiento_electricidad_gas": 0.403,
              "porcentaje_agua_caliente": 0.16,
              "rendimiento_agua_fria_agua_caliente": 0.67,
              "coeficiente_emisiones_CO2": 0.182,
              "tiempo_arranque": 60,
              "tiempo_parada": 30,
              "estado": "Encendido",
              "fee": 7.316,
              "tiempo_minimo_acoplamiento": 4,
              "tiempo_minimo_parada": 3
            },
          ],
          "planta_calderas_gas": [
            {
              "nombre": "Caldera de gas 6",
              "potencia_gas_maxima": 24.54,
              "potencia_gas_minima": 2.00,
              "potencia_vapor_maxima": 20.368,
              "rendimiento_vapor_gas": 0.83,
              "coeficiente_emisiones_CO2" : 0.182,
              "estado_inicial_equipo": "Parado"
            },
            {
              "nombre": "Caldera de gas 7",
              "potencia_gas_maxima": 35.00,
              "potencia_gas_minima": 3.0,
              "potencia_vapor_maxima": 29.05,
              "rendimiento_vapor_gas": 0.83,
              "coeficiente_emisiones_CO2" : 0.182 ,
              "estado_inicial_equipo": "Parado"
            },
            {
              "nombre": "Caldera de gas 10",
              "potencia_gas_maxima": 18.00,
              "potencia_gas_minima": 1.50,
              "potencia_vapor_maxima": 15.66,
              "rendimiento_vapor_gas": 0.87,
              "coeficiente_emisiones_CO2" : 0.182,
              "estado_inicial_equipo": "Parado"
            }
          ],
          "planta_compresores": [
            {
              "nombre": "Compresor propio 3",
              "potencia_maxima": 90.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.333,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor propio 4",
              "potencia_maxima": 90.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.333,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor propio 5",
              "potencia_maxima": 90.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.333,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor propio 6",
              "potencia_maxima": 355.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.521,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor propio 7",
              "potencia_maxima": 355.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.521,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor propio 8",
              "potencia_maxima": 355.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.521,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 0.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor alquiler 1",
              "potencia_maxima": 465.39,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.088,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 400.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor alquiler 2",
              "potencia_maxima": 191.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 2.047,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 30.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor alquiler 3",
              "potencia_maxima": 146.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 1.801,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 28.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor alquiler 4",
              "potencia_maxima": 142.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.077,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 77.00,
              "coste_uso": 0.00,
            },
            {
              "nombre": "Compresor alquiler 5",
              "potencia_maxima": 239.00,
              "potencia_minima": 0.00,
              "rendimiento_frio_electricidad": 3.104,
              "estado_inicial_equipo": "Parado",
              "coste_alquiler": 77.00,
              "coste_uso": 0.00,
            },
   
          ],
        },  
        ro_cogeneracion: {},
        meses_unicos:{},
        
      
      
        resultado: {},
        gas_parametros:{
          impuesto: 0.54,
          fnee: 0.975,
          term_a: 2.50,
          term_bmc: 1.00,
          term_bcg: 1.001,
          peaje: 81.84,
          //input_prov: 3,
          //usar_input: enHorarioLaboral ? 1 : 0,
          //Qd: 3200 // 3200 MWh de caso base para ver si en el correo de nominación hay que avisar de contratar más kWh
          },

          gas_swap:[
          {
                id:"swap1",
                cantidad: 0.00,
                precio: 0.00
              },
               {
                id:"swap2",
                cantidad: 0.00,
                precio: 0.00
              },
               {
                id:"swap3",
                cantidad: 0.00,
                precio: 0.00
              }
            ],
        gas_precios_MIBGAS:[
            35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10,
            35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10, 35.10,
            35.10, 35.10, 35.10, 35.10
        ],
        gas_precios_manual: Array(24 * 7).fill(35.1),
  
        //--------------------------------------------------------------------
        programa: {},
        resultado_operacion: {},
        resultado_economico: {},
        resultados: [],
        mostrar_boton_descargar_in: "",
        vista_operador: false,


        //--------------------------------------        
        acceso_concedido: false,

  
      };
    },
  
    
    created() {
      this.$nextTick(() => {
        this.generarDisponibilidad();
        this.generarAcoplamiento();
        this.actualizarAcoplamiento(this.estadoAcoplamiento);
        if (this.configuracion.modoEjecucionTexto !== "Backtesting" &&
          this.configuracion.modoEjecucionTexto !== "Planificación") {
        this.generarDemandas(); // Solo si estamos en modo normal
      }
        
        this.generarManuales()
        
      });
  
      // Cargar configuración proporcionada desde `main.js`
      fetch('/config.json')
        .then((response) => response.json())
        .then((config) => {
          this.mostrar_boton_descargar_in = config.mostrar_boton_descargar_in;  
          this.usuarios_operadores = config.usuarios_operadores;
          
          
          
          if (this.usuarios_operadores.includes(this.usuario)) {
              this.vista_operador = true;
          } else {
              this.vista_operador = false;
          }
          
                  
        })
        .catch((error) => {
          console.error('Error al cargar la configuración:', error);
          
        });
  
  
    },
    
  
    computed: {
      mostrarBotonesAccesoPrecios() {
    return this.vista_operador && String(this.tab1) === "3";
  }
    /*modoEjecucionTransformado() {
      switch (this.configuracion.modoEjecucion) {
        case 3:
          return 2; // Backtesting se convierte en 2
        case 4:
          return 0; // Planificación se convierte en 0
        default:
          return this.configuracion.modoEjecucion;
      }
    },*/
   
  },
    methods: {
      validarNombreSimulacion() {
        const nombre = this.metadata?.simulation_name?.trim();

        const nombresPorDefecto = ["Sin título", "Untitled"];

        if (!nombre || nombresPorDefecto.includes(nombre)) {
          Swal.fire(
            "Nombre obligatorio",
            "Debes introducir un nombre para la simulación antes de continuar.",
            "warning"
          );
          return false;
        }

        return true;
      },

      async obtenerRo() {
        const formatoFechaRO = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${year}-${month}-01`;
    };
       
          const partes = this.configuracion.fechaActual.split('/');
          // El constructor de Date usa el formato YYYY, MM (0-11), DD
          const fechaOriginal = new Date(partes[2], partes[1] - 1, partes[0]);

         let startDate
        let endDate
        if (this.configuracion.modoEjecucionTexto=="Planificación"){
          console.log("Planificación Ro")
          startDate=fechaOriginal
          
          //Revisar bisiestos
          endDate=new Date(fechaOriginal)
          endDate.setDate(endDate.getDate() + 364);
         
        }
        else if (this.configuracion.modoEjecucionTexto=="Backtesting"){
        startDate=fechaOriginal

          endDate=new Date(fechaOriginal)
          endDate.setDate(endDate.getDate() + (this.configuracion.horizonte-1));
        }
        else{
          startDate=new Date(fechaOriginal)
          startDate.setDate(startDate.getDate() + 1);
          //console.log("Fechas start_date-> ", startDate, " fecha_orignal ", fechaOriginal)
          endDate=new Date(startDate)
          endDate.setDate(endDate.getDate() + (this.configuracion.horizonte-1));
        }
        console.log("Fechas: ", startDate, " ",this.configuracion.horizonte ," -- ", endDate)
       startDate=formatoFechaRO(startDate)
       endDate=formatoFechaRO(endDate)
        try {
          const response = await axios.get(
            process.env.VUE_APP_API_BASE_URL + "/api/ro",
            {
              headers: { Authorization: "Bearer " + store.state.token },
              params:{
                start_date:startDate,
                end_date:endDate
              }
            }
          );
         
             this.lista_ro=response.data.reduce((acumulador,row)=>{
              console.log("FIla: ", row)
              const fecha = new Date(row['DATE_RO']);
              let mesAnio = fecha.toLocaleDateString("es-ES", { month: "short", year: "numeric" });
              acumulador[mesAnio]=row['VALUE']
              return acumulador
            },{})
             console.log("Respuesta: ", this.lista_ro)
             this.ro_cogeneracion=this.lista_ro
        } catch (error) {
          console.error("Error al obtener ro:", error);
        }
      },

      //Se devuelven las horas de diferencia con el horizonte (por si cambio de hora)
      //Se usa la fecha actual y el horizonte en días para sacar el horizonte en horas
      actualizar_horizonte_horas(){
        
        const partes = this.configuracion.fechaActual.split("/");
        let currentDate = new Date(partes[2], partes[1] - 1, partes[0]);

        if(this.configuracion.modoEjecucionTexto!="Backtesting" && this.configuracion.modoEjecucionTexto!="Planificación" ){
          console.log("Modo: ", this.configuracion.modoEjecucionTexto)

          currentDate.setDate(currentDate.getDate()+1)
        }
       
        
        
        const endDate = new Date(currentDate);
        endDate.setDate(currentDate.getDate() + this.configuracion.horizonte);
        console.log("horizonte current ", this.configuracion.horizonte)
        // La diferencia en milisegundos
        const diferencia_ms = endDate.getTime() - currentDate.getTime();
        // Convertimos de milisegundos a horas
        this.horizonte_horas = diferencia_ms / (1000 * 60 * 60); 
        console.log("Actualizando horizonte_horas ", this.horizonte_horas)
        //console.log(`endDate ${endDate}   ->  currentDate ${currentDate} `, this.horizonte_horas)
      },
      async obtener_lista_simulaciones() {
        if (this.listaSimulacionesCargada) {
          return this.lista_simulaciones;
        }

        this.loading = true;
        this.mensaje_loading = this.$t('simulaciones.descargando');

        try {
          const response = await axios({
            method: 'get',
            url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion',
            withCredentials: true,
            headers: { 
              Authorization: "Bearer " + store.state.token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'                
            },      
          });

          let myObject = response.data;

          const lista = Array.isArray(myObject)
            ? myObject
            : Array.isArray(myObject?.data)
              ? myObject.data
              : Array.isArray(myObject?.data?.data)
                ? myObject.data.data
                : [];

          this.lista_simulaciones = lista.filter(item => item.status !== 7);

          if (this.vista_operador === true) {
            this.lista_simulaciones = this.lista_simulaciones.filter(
              item => item.username === store.state.usuarioNombre
            );
          }

          this.listaSimulacionesCargada = true;

          this.$store.dispatch('actualizarListaSimulations', this.lista_simulaciones);

          return this.lista_simulaciones;

        } catch (error) {
          console.error("Error obteniendo lista de simulaciones:", error);
          this.lista_simulaciones = [];
          this.listaSimulacionesCargada = true;
          return [];
        } finally {
          this.cargando = false;
          this.loading = false;
        }
      },
      //Cuando se modifican las disponibilidades
      revisarDisponibilidades(){
        console.log("Disponibilidades cambiadas", this.disponibilidad['cogeneracion'])
        let motores_revisar_ac=[]
        let motores_revisar_p=[]
        this.planta.planta_motores_cogeneracion.forEach((motor,index)=>{
         
          if(this.estadoAcoplamiento[index]=='Si'){
             console.log("estado acop: ", index," ", this.estadoAcoplamiento[index])
         const resAc =this.revisarColumnaEnMatriz(motor['nombre'],motor['tiempo_minimo_acoplamiento'],1)
          if(! resAc[0] ){

            motores_revisar_ac.push(motor['nombre']+" - "+resAc[1])
          }
          const resPar=this.revisarColumnaEnMatriz(motor['nombre'],motor['tiempo_minimo_parada'],0)
          if(  !resPar[0]){
            motores_revisar_p.push(motor['nombre']+" - "+resPar[1])
          }
         
         }
        })
        if(motores_revisar_ac.length>0 || motores_revisar_p.length>0){
          console.log("Incongruencias disponibilidad")
          let mensaje_error=this.$t('mensajes.revisar_disponibilidad')+"<br>";
          
          (motores_revisar_ac.length>0)? mensaje_error+=this.$t('mensajes.revisar_disponibilidad_ac')+"<ul><li>"+ motores_revisar_ac.join('</li><li>')+"</li></ul><br>":mensaje_error+="";
          
          (motores_revisar_p.length>0)? mensaje_error+=this.$t('mensajes.revisar_disponibilidad_p')+"<br><ul><li>"+ motores_revisar_p.join('</li><li>')+"</li></ul><br>" : mensaje_error+=""
          
          this.muestra_mensaje_error(mensaje_error)
          console.log(mensaje_error)
          return true
        }
        return false
      },
      //Funciones que se llaman al cambiar el tiempo minimo de acoplamiento o de parada, para revisar si se cumplen las condiciones y avisar
      //Le llega el motor entero con el que comparar en disponibilidad y acoplamiento
      handleTMinAc(motor){
        console.log("handleTMinAc ", motor['nombre'], " ", motor['tiempo_minimo_acoplamiento'])
        if (this.revisarColumnaEnMatriz(motor['nombre'],motor['tiempo_minimo_acoplamiento'],0)){
          console.log("handleTMinAc bien", )
        }else{
          this.muestra_mensaje_error(this.$t('mensajes.revisar_disponibilidad_ac')+" "+ (motor['nombre']))
          //alert("No se cumplen las horas mínimas de acoplamiento ", (motor['nombre']), " tiene " )
        }
      },
      handleTMinPar(motor){
        console.log("handleTMinPar ", motor['nombre'], " ", motor['tiempo_minimo_parada'])
        if (this.revisarColumnaEnMatriz(motor['nombre'],motor['tiempo_minimo_parada'],1)){
          console.log("handleTMinPar bien", )
        }else{
          this.muestra_mensaje_error(this.$t('mensajes.revisar_disponibilidad_p')+" "+ (motor['nombre']))
          //alert("No se cumplen las horas mínimas de parada")
        }
      },
      //Función para revisar si en matriz de disponibilidad, si en una columna de motor cog, 
      //Se revisa si en la columna nombre_motor hay una cantidad mayor o igual que 'cantidad' de 'valorBuscado'
      //Si lo hay devuelve cierto, si no devuelve falso (error)
      revisarColumnaEnMatriz(nombre_motor,cantidad,valorBuscado){
       console.log("Buscando : ", valorBuscado)
        let cuenta_cantidad=0
        let contador_horas=0
       for (const [index,row] of this.disponibilidad['cogeneracion'].entries()){
          /* Revisar cada vez que aparezca un 1 o un 0, este tiene que estar x veces seguidas, según la cantidad
          Al final se va a hacer entero, según gams se ve todo seguido, no teniendo en cuenta días
          */
          if (row['disponibilidad'][nombre_motor]==valorBuscado){
           
            contador_horas+=1
            if (contador_horas>=cuenta_cantidad){
               console.log("Motor: ", row['disponibilidad'])
              cuenta_cantidad=contador_horas
            }
            
          }else{
            console.log("contador_horas ", contador_horas)
             //En cuanto un contador tenga mínimo un valor y sea menor que el buscado 
          if(contador_horas>0 && contador_horas<cantidad){
            console.log("Index: ", index-1," Cantidad:" ,cantidad," Hora: ",this.disponibilidad['cogeneracion'][index-1]['hora'] )
            return [false,this.disponibilidad['cogeneracion'][index-1]['hora']]
          }
            contador_horas=0
          }
        }
        //console.log("Horas encontradas seguidas de ",valorBuscado , " : ", cuenta_cantidad)
        //Revisión final
        return [true,""]
      },
      //Función para detectar cambios de una matriz con otra solo en una columna
      detectChangeInColumn(oldArray,newArray, column) {
      
      for (let i = 0; i < newArray.length; i++) {
        const newValue = newArray[i][column];
        const oldValue = oldArray[i][column];
        console.log("VALORES: ", newValue,oldValue)
        // Comparamos el valor de la columna
        if (newValue !== oldValue) {
          console.log(`¡Cambio detectado en la columna '${column}' en la fila ${i + 1}!`);
          console.log(`Valor anterior: ${oldValue}`);
          console.log(`Valor nuevo: ${newValue}`);
        
        }
      }
    },
    formatearNumeroComa(valor, decimales = 2) {
  if (valor === "" || valor == null || valor === "-") return "";

  const numero = Number(String(valor).replace(",", "."));

  if (!Number.isFinite(numero)) return "";

  return numero
    .toFixed(decimales)
    .replace(".", ",")
    .replace(/,?0+$/, "");
},

normalizarNumeroExcel(valor, decimales = 2) {
  if (valor === "" || valor == null || valor === "-") return "";

  if (typeof valor === "number") {
    if (!Number.isFinite(valor)) return "";
    return Number(valor.toFixed(decimales));
  }

  let texto = String(valor).trim();

  if (
    texto === "" ||
    texto === "-" ||
    texto.includes("MWh") ||
    texto.includes("EUR") ||
    texto.includes("%") ||
    /[a-zA-ZáéíóúÁÉÍÓÚñÑ]/.test(texto)
  ) {
    return "";
  }

  // Corrige textos tipo "2," o "20,"
  texto = texto.replace(/[,.]$/, "");

  // Formato español: "1.234,56"
  if (texto.includes(".") && texto.includes(",")) {
    texto = texto.replace(/\./g, "").replace(",", ".");
  }
  // Formato español simple: "12,34"
  else if (texto.includes(",")) {
    texto = texto.replace(",", ".");
  }
  // Formato miles español sin decimales: "1.234"
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(texto)) {
    texto = texto.replace(/\./g, "");
  }

  const numero = Number(texto);

  if (!Number.isFinite(numero)) return "";

  return Number(numero.toFixed(decimales));
},

aplicarFormatoNumeroExcel(cell, decimales = 2) {
  if (typeof cell.value !== "number") return;

  const numeroRedondeado = Number(cell.value.toFixed(decimales));
  cell.value = numeroRedondeado;

  const tieneDecimales = !Number.isInteger(numeroRedondeado);

  // Si la celda ya tenía unidad en el formato, la conservamos
  const formatoAnterior = cell.numFmt || "";
  const unidadMatch = formatoAnterior.match(/"([^"]+)"/);
  const unidad = unidadMatch ? unidadMatch[1] : "";

  const formatoBase = tieneDecimales
    ? `#,##0.${"#".repeat(decimales)}`
    : "#,##0";

  cell.numFmt = unidad
    ? `${formatoBase} "${unidad}"`
    : formatoBase;
},

forzarDecimalesConComaEnWorkbook(workbook) {
  workbook.eachSheet((worksheet) => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        const valor = cell.value;

        if (typeof valor === "number") {
          this.aplicarFormatoNumeroExcel(cell, 2);
          return;
        }

        if (typeof valor === "string") {
          const numero = this.normalizarNumeroExcel(valor, 2);

          if (numero !== "") {
            cell.value = numero;
            this.aplicarFormatoNumeroExcel(cell, 2);
          }
        }
      });
    });
  });
},

async exportarExcelCompleto() {
  await this.$nextTick();

  const workbook = new ExcelJS.Workbook();

  const hojaPrograma = workbook.addWorksheet("Programa");
  this.$refs.componentePrograma?.agregarDatosAlWorkbook?.(hojaPrograma);

  const hojaOperacion = workbook.addWorksheet("Resultados Operación");
  this.$refs.componenteResultadosOper?.agregarDatosAlWorkbook?.(hojaOperacion);

  const hojaEconomicos = workbook.addWorksheet("Resultados Económicos");
  this.$refs.componenteResultadosEcon?.agregarDatosAlWorkbook?.(hojaEconomicos);

  this.forzarDecimalesConComaEnWorkbook(workbook);

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "informe-completo.xlsx");
},
  
      modoEjecucionTransformado() {
    switch (this.configuracion.modoEjecucion) {
      case 3:
        return 2;
      case 4:
        return 2;
      default:
        return this.configuracion.modoEjecucion;
    }

  },
    // Función para formatear la fecha a "YYYY-MM-DD HH:mm"
    formatoFecha(fecha) {
      const año = fecha.getFullYear();
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga 2 dígitos
      const día = fecha.getDate().toString().padStart(2, '0'); // Asegura que el día tenga 2 dígitos
      const hora = fecha.getHours().toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
      const minuto = fecha.getMinutes().toString().padStart(2, '0'); // Asegura que el minuto tenga 2 dígitos
  
      return `${año}-${mes}-${día} ${hora}:${minuto}`;
    },
     formatoFechaAcoplamiento(fecha) {
      const año = fecha.getFullYear();
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga 2 dígitos
      const día = fecha.getDate().toString().padStart(2, '0'); // Asegura que el día tenga 2 dígitos
      const hora = fecha.getHours().toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
      const minuto = fecha.getMinutes().toString().padStart(2, '0'); // Asegura que el minuto tenga 2 dígitos
  
      return `${día}-${mes}-${año} ${hora}:${minuto}`;
    },
    generarManuales(){
      const modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
          if (modoTexto === "planificación") {
            this.generarPreciosPlanificacion();
            return;
          }
      let valores_elec2= [117.02, 113.14, 112.38, 112.64, 112.58, 112.88, 116.84, 120.72, 116.84, 112.82,111.92, 98.00, 92.98, 92.79, 88.99, 83.00, 81.80, 81.80, 94.37, 109.20, 117.60,
    132.66, 125.50, 117.14, 14.56, 10.94, 10.00, 7.80, 8.00, 10.94, 22.90, 35.01, 35.00,10.94, 3.25, 2.49, 1.79, 1.83, 0.00, 0.44, 1.06, 0.44, 5.39, 17.60, 35.40, 59.14,
    43.90, 35.64, 35.01, 35.01, 35.00, 35.00, 35.00, 34.43, 35.00, 41.00, 35.00, 28.90,16.20, 4.99, 6.10, 5.00, 3.25, 2.51, 0.44, 3.25, 9.08, 27.94, 40.00, 66.52, 50.02,
    42.00, 35.00, 33.11, 27.94, 18.90, 16.20, 18.90, 22.23, 26.22, 16.20, 2.10, 0.01,0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 3.25, 30.00, 35.01, 35.02, 35.01,
    30.00, 26.87, 24.13, 22.62, 22.86, 24.81, 26.87, 25.63, 16.72, 3.25, 1.88, 0.44,0.00, -0.04, -0.58, -0.10, 0.00, 0.00, 3.25, 6.10, 29.90, 54.33, 51.61, 50.15, 63.58,
    55.99, 51.91, 53.96, 51.08, 53.96, 57.10, 84.03, 86.89, 61.54, 45.13, 35.00, 18.90,10.00, 6.10, 4.99, 4.23, 5.00, 9.90, 37.62, 75.10, 97.69, 93.20, 84.42, 81.73, 77.64,
    74.77, 68.24, 66.82, 69.09, 75.98, 99.87, 75.62, 35.00, 10.00, 3.60, 0.00, 0.00, 0.00,0.00, 0.00, 0.00, 0.00, 35.00, 56.18, 67.44, 62.00, 50.01];
    let valores_elec =valores_elec2.slice(0,24*7)
      let valores_gas= Array(24*7).fill(35.1);

      const elec_manual = [];
      const gas_manual = [];
      const total = this.horizonte_horas
      while (elec_manual.length < total) {
        const elementosRestantes = total - elec_manual.length;
        const elementosToAdd = valores_elec.slice(0, elementosRestantes);
      elec_manual.push(...elementosToAdd);
      }
      while (gas_manual.length < total) {
        const elementosRestantes = total - gas_manual.length;
        const elementosToAdd = valores_gas.slice(0, elementosRestantes);
        gas_manual.push(...elementosToAdd);
      }

      let partes = this.configuracion.fechaActual.split("/");
      //console.log("HORIZONTE: ",this.configuracion.horizonte )
        const fechaBase = new Date(partes[2], partes[1] - 1, partes[0]);
        fechaBase.setDate(fechaBase.getDate()+1);
        fechaBase.setHours(0,0,0,0);
  
        // Crear arrays de objetos para las demandas de vapor y frío
        this.elec_precios_manual = elec_manual.map((valor, index) => {
          // Incrementar la hora para cada valor
          let fechaHora = new Date(fechaBase.getTime()+ index * 60 * 60 * 1000);
         
          return {
            valor: valor,
            horizonte: this.formatoFecha(fechaHora), // Fecha en formato ISO
            hora: 'H'+(index+1), // Hora en formato 24h
          };
        });
  
        this.gas_precios_manual = gas_manual.map((valor, index) => {
          // Incrementar la hora para cada valor
          let fechaHora = new Date(fechaBase.getTime()+ index * 60 * 60 * 1000);
          
  
          return {
            valor: valor,
            horizonte: this.formatoFecha(fechaHora), // Fecha en formato ISO
            hora: 'H'+(index+1), // Hora en formato 24h
          };
        });
    },
    
      generarDemandas() {
  const modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
  if (modoTexto === "backtesting" || modoTexto === "planificación") {
    this.generarDatosDemandaHistorico();
    return;
  }

  const total = this.horizonte_horas
  console.log("Total horas ",this.horizonte_horas)
  // Valores base si no hay anteriores
  let valoresBase = [
    60.948, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512,
    62.078, 62.644, 62.644, 62.644, 63.766, 63.207, 62.644, 61.512,
    61.512, 62.644, 63.207, 63.766, 64.316, 64.857, 65.385, 65.385
  ];

  let frioBase = [
    2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50,
    2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50,
    2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50, 2.50
  ];

  // Si ya hay valores anteriores, los tomamos como base
  if (this.demanda_vapor.length > 0) {
    valoresBase = this.demanda_vapor.map(obj => obj.valor);
    console.log("Ya existen demandas de vapor: ", valoresBase);
  }
  if (this.demanda_frio.length > 0) {
    frioBase = this.demanda_frio.map(obj => obj.valor);
    console.log("Ya existen demandas de frío: ", frioBase);
  }

  // Rellenar repitiendo los valores hasta alcanzar el tamaño total
  const valores = [];
  const frio = [];
  while (valores.length < total) {
    const elementosRestantes = total - valores.length;
     const elementosToAdd = valoresBase.slice(0, elementosRestantes);
   valores.push(...elementosToAdd);
  }
  while (frio.length < total) {
    const elementosRestantes = total - frio.length;
     const elementosToAdd = frioBase.slice(0, elementosRestantes);
    frio.push(...elementosToAdd);
  }

  // Cortar a longitud exacta
  const valoresFinales = valores.slice(0, total);
  const frioFinales = frio.slice(0, total);
  console.log("Valores demanda len: ", valoresFinales.length)
  console.log("Valores demandaFrio len: ", frioFinales.length)
  console.log("Total ", this.horizonte_horas)
  // Obtener la fecha base desde configuracion.fechaActual
  const partes = this.configuracion.fechaActual.split("/");
  const fechaBase = new Date(partes[2], partes[1] - 1, parseInt(partes[0], 10));
  fechaBase.setDate(fechaBase.getDate() + 1);
  fechaBase.setHours(0, 0, 0, 0);
  console.log("Generando demandas desde fecha: ", fechaBase);

  // Crear arrays de objetos para las demandas de vapor y frío
  this.demanda_vapor = valoresFinales.map((valor, index) => {
    const fechaHora = new Date(fechaBase.getTime()+ index * 60 * 60 * 1000);
    //fechaHora.setHours(fechaHora.getHours() + index);
    return {
      valor: valor,
      horizonte: this.formatoFecha(fechaHora),
      hora: 'H' + (index + 1),
    };
  });

  this.demanda_frio = frioFinales.map((valor, index) => {
    const fechaHora = new Date(fechaBase.getTime()+ index * 60 * 60 * 1000);
    return {
      valor: valor,
      horizonte: this.formatoFecha(fechaHora),
      hora: 'H' + (index + 1),
    };
  });

  console.log("✅ Demandas generadas o ajustadas correctamente.");
},


  
      
      generarDisponibilidad() {
        const modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
        if (modoTexto === "planificación") {
          this.generarDisponibilidadPlanificacion();
          return;
        } else if (modoTexto === "backtesting") {
          this.generarDisponibilidadHistorico();
          return;
        }
        console.log("Generando disponibilidad con horizonte:", this.configuracion.horizonte);
  
        let fechaManana = this.configuracion.fechaActual;    
        const [dia, mes, anio] = fechaManana.split("/").map(Number);
        fechaManana = new Date(anio, mes - 1, dia);
        fechaManana.setDate(fechaManana.getDate() + 1);
  
        // generar el formato `YYYY-MM-DD HH:MM`
        /* const formatoFechaHora = (fecha, hora) => {
            let año = fecha.getFullYear();
            let mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
            let dia = fecha.getDate().toString().padStart(2, "0");
            let horas = hora.toString().padStart(2, "0");
  
            return `${año}-${mes}-${dia} ${horas}:00`;
        }; */
  
        const motoresCogeneracion = [
            "Motor cogeneración 1",
            "Motor cogeneración 2",
            "Motor cogeneración 3",
            "Motor cogeneración 4",
            "Motor cogeneración 5",
            "Motor cogeneración 6",
            "Motor cogeneración 7",
            "Motor cogeneración 8"
        ];
  
        const calderasGas = ["Caldera de gas 6", "Caldera de gas 7", "Caldera de gas 10"];
        const calderasElectricas = ["Caldera eléctrica 1", "Caldera eléctrica 2"];
  
        let disponibilidadCogeneracion = [];
        let disponibilidadCalderaGas = [];
        let disponibilidadCalderaElectrica = [];
  
        let contadorHoras = 1;
  
        for (let hora = 0; hora < this.horizonte_horas; hora++) {
              let fechaHora = new Date(fechaManana.getTime() + hora  * 60 * 60 * 1000); //  en `YYYY-MM-DD HH:MM`
              let key = this.formatoFecha(fechaHora);
                // Intentar recuperar valores anteriores
                const disponibilidadExistenteCogeneracion = this.disponibilidad.cogeneracion?.find(d => d.horizonte === key);
                const disponibilidadExistenteCalderaGas = this.disponibilidad.caldera_gas?.find(d => d.horizonte === key);
                const disponibilidadExistenteCalderaElectrica = this.disponibilidad.caldera_electrica?.find(d => d.horizonte === key);
  
                disponibilidadCogeneracion.push({
                    horizonte: key,
                    hora: `H${contadorHoras}`,
                    disponibilidad: motoresCogeneracion.reduce((acc, motor) => {
                        acc[motor] = disponibilidadExistenteCogeneracion ? disponibilidadExistenteCogeneracion.disponibilidad[motor] : 1;
                        return acc;
                    }, {})
                });
  
                disponibilidadCalderaGas.push({
                    horizonte: key,
                    hora: `H${contadorHoras}`,
                    disponibilidad: calderasGas.reduce((acc, caldera) => {
                        acc[caldera] = disponibilidadExistenteCalderaGas ? disponibilidadExistenteCalderaGas.disponibilidad[caldera] : 1;
                        return acc;
                    }, {})
                });
  
                disponibilidadCalderaElectrica.push({
                    horizonte: key,
                    hora: `H${contadorHoras}`,
                    disponibilidad: calderasElectricas.reduce((acc, caldera) => {
                        acc[caldera] = disponibilidadExistenteCalderaElectrica ? disponibilidadExistenteCalderaElectrica.disponibilidad[caldera] : 1;
                        return acc;
                    }, {})
                });
  
                contadorHoras++;
            
        }
  
        this.disponibilidad.cogeneracion = [...disponibilidadCogeneracion];
        this.disponibilidad.caldera_gas = [...disponibilidadCalderaGas];
        this.disponibilidad.caldera_electrica = [...disponibilidadCalderaElectrica];
  
        console.log(" Datos de disponibilidad generados correctamente:", this.disponibilidad);
  },
  
  
  
  generarAcoplamiento() {
    const modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
          if (modoTexto === "backtesting" || modoTexto === "planificación") {
            this.generarAcoplamientoHistorico();
            return;
          }
      if (!this.acoplamiento_equipos) {
          this.acoplamiento_equipos = { cogeneracion: [] };
      }
  
      console.log("Generando datos de acoplamiento con horizonte:", this.configuracion.horizonte);
  
      //const fechaManana = new Date();
      //fechaManana.setDate(fechaManana.getDate() + 1);
  
      let fechaManana = this.configuracion.fechaActual; //new Date();    
      const [dia, mes, anio] = fechaManana.split("/").map(Number);
      fechaManana = new Date(anio, mes - 1, dia);
      fechaManana.setDate(fechaManana.getDate() + 1);
       fechaManana.setHours(0,0,0,0)
      const total=this.horizonte_horas
      const motoresCogeneracion = [
          "Motor cogeneración 1",
          "Motor cogeneración 2",
          "Motor cogeneración 3",
          "Motor cogeneración 4",
          "Motor cogeneración 5",
          "Motor cogeneración 6",
          "Motor cogeneración 7",
          "Motor cogeneración 8"
      ];
  
      let acoplamientoMap = [];
      //let contadorHoras = 1;
  
      for (let hora = 0; hora < total; hora++) {


        let fechaHora = new Date(fechaManana.getTime() + hora * 60 * 60 * 1000); 
              let key = this.formatoFechaAcoplamiento(fechaHora);
  
              // Intentar recuperar valores anteriores
              const acoplamientoExistente = this.acoplamiento_equipos.cogeneracion?.find(d => d.horizonte === key);
  
              acoplamientoMap.push({
                  horizonte: key,
                  hora: `H${hora+1}`,
                  acoplamiento: motoresCogeneracion.reduce((acc, motor) => {
                    let valor = acoplamientoExistente
                      ? parseFloat(acoplamientoExistente.acoplamiento[motor])
                      : 1;

                    if (valor > 1) valor = valor / 100;

                    acc[motor] = parseFloat(valor.toFixed(4));
                    return acc;
                  }, {})
              });
  
          
      }
  
      this.acoplamiento_equipos.cogeneracion = [...acoplamientoMap];
  },
  
  
    actualizarAcoplamiento(nuevoEstado) {
      this.estadoAcoplamiento = [...nuevoEstado];
  
      // Actualiza el estado en `acoplamiento_equipos.cogeneracion`
      this.acoplamiento_equipos.cogeneracion.forEach((fila, index) => {
        fila.acoplado = nuevoEstado[index] || "No";
      });
    },
  
    generarSetMCFij() {
      return this.estadoAcoplamiento
        .map((estado, index) => (estado === "Si" ? `Motor cogeneración ${index + 1}` : null))
        .filter(Boolean)
        .join("\n");
    },

    generarAcoplamientoHistorico() {
      console.log("Generando acoplamiento desde histórico...");

      this.isLoading = true;
      this.mensaje_loading = "Cargando datos backtesting...";

      this.$nextTick(() => {
        try {
          const partes = this.configuracion.fechaActual.split("/");
          let start_date = new Date(partes[2], partes[1] - 1, partes[0]);
          start_date.setHours(0, 0, 0, 0);
          let total_dias;
          let modoTexto = (this.configuracion.modoEjecucionTexto || "").trim().toLowerCase();
          if (modoTexto === "backtesting") {
            start_date.setDate(1); // primer día del mes
            const anio = start_date.getFullYear();
            const mes = start_date.getMonth() + 1;
            total_dias = new Date(anio, mes, 0).getDate(); // días del mes
          } else if (modoTexto === "planificación") {
            total_dias = this.configuracion.horizonte;
          } else {
            start_date.setDate(start_date.getDate() + 1); // saltar al día siguiente
            total_dias = this.configuracion.horizonte || 1;
          }
        
          console.log(` Generando acoplamiento desde ${this.formatoFecha(start_date).split(" ")[0]} por ${total_dias} días`);

          this.acoplamiento_equipos = { cogeneracion: [] };
          this.$emit("update:acoplamiento_equipos", { cogeneracion: [] });

          const datosAcoplamiento = [];
          const horasGeneradas = new Set(); // Evitar duplicados
          let contadorHora = 1;

          const motoresCogeneracion = [
            "Motor cogeneración 1", "Motor cogeneración 2", "Motor cogeneración 3",
            "Motor cogeneración 4", "Motor cogeneración 5", "Motor cogeneración 6",
            "Motor cogeneración 7", "Motor cogeneración 8"
          ];
          //let total_horas=total_dias*24

          for (let i = 0; i < this.horizonte_horas; i++) {
             let fechaHora = new Date(start_date.getTime() + i * 60 * 60 * 1000); 
              let horizonteStr = this.formatoFecha(fechaHora);

              /* if (horasGeneradas.has(horizonteStr)) {
                console.warn("Hora duplicada detectada, saltando:", horizonteStr);
                continue; 
              } */
              horasGeneradas.add(horizonteStr);

              datosAcoplamiento.push({
                horizonte: horizonteStr,
                hora: `H${contadorHora}`,
                acoplamiento: motoresCogeneracion.reduce((acc, motor) => {
                  acc[motor] = (1).toFixed(4);
                  return acc;
                }, {})
              });

              contadorHora++;
            
          }

          this.acoplamiento_equipos.cogeneracion = [...datosAcoplamiento];
          this.$emit("update:acoplamiento_equipos", {
            cogeneracion: [...this.acoplamiento_equipos.cogeneracion]
          });

          console.log("Datos de acoplamiento generados correctamente.");
          console.log("Primer horizonte:", datosAcoplamiento[0]);
        } catch (error) {
          console.error("Error en la generación de acoplamiento:", error);
          this.mensaje_loading = "Error al cargar datos. Intenta nuevamente.";
        } finally {
          this.isLoading = false;
        }
      });
    },







  
    generarDatosRoCogeneracion(horizonte) {
      const modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
          if (modoTexto === "backtesting" || modoTexto === "planificación") {
            this.generarDatosRoCogeneracionHistorico();
            return;
          }
      //alert(this.configuracion.fechaActual)
      let fechaActual = this.configuracion.fechaActual; //new Date();
      
      const [dia, mes, anio] = fechaActual.split("/").map(Number);
      fechaActual = new Date(anio, mes - 1, dia);
  
  
      fechaActual.setDate(fechaActual.getDate() + 1);
  
      let mesesUnicos = {}
  
      for (let dia = 0; dia < horizonte; dia++) {
          for (let hora = 0; hora < 24; hora++) { // Agregar cada hora del día
              const fecha = new Date(fechaActual);
              fecha.setDate(fechaActual.getDate() + dia);
              let mesAnio = fecha.toLocaleDateString("es-ES", { month: "short", year: "numeric" });
              //En csv sept se convierte en sep, así nos ahorramos ese problema
              if(mesAnio.split(' ')[0]=='sept'){
                mesAnio.replace('t','');
              }
              if (!(mesAnio in mesesUnicos)) {
                mesesUnicos[mesAnio] = 78.80;
              }
          }
      }
      this.meses_unicos=mesesUnicos;
      const merged = { ...this.meses_unicos, ...this.ro_cogeneracion };
      console.log("Meses unicos: ", this.meses_unicos)
      console.log("merged: ", merged)
      console.log("Ro: : ", this.ro_cogeneracion)
      this.ro_cogeneracion=merged
      //this.ro_cogeneracion=mapaFiltrado;
  },
  generarDatosRoCogeneracionHistorico() {
  const mesesUnicos = {}

  const partes = this.configuracion.fechaActual.split("/");
  const fecha = new Date(partes[2], partes[1] - 1, 1); // forzamos día 1

  const meses = {
    "01": "ene", "02": "feb", "03": "mar", "04": "abr", "05": "may", "06": "jun",
    "07": "jul", "08": "ago", "09": "sept", "10": "oct", "11": "nov", "12": "dic"
  };

  let numeroMeses = 0;
  if (this.configuracion.modoEjecucion === 3) { // Backtesting
    numeroMeses = 1;
  } else if (this.configuracion.modoEjecucion === 4) { // Planificación
    //Si la simulación es en mitad de un mes, serán 13 meses, 
    // por ejemplo: de junio 2025 a junio2026
      if(parseInt(partes[0])>1){
        numeroMeses=13;
      }
      else{
          numeroMeses = 12;
      }
  
  } else {
    return; // no generar para otros modos
  }

  for (let i = 0; i < numeroMeses; i++) {
    const mesNumero = (`0${fecha.getMonth() + 1}`).slice(-2);
    const anioCompleto = fecha.getFullYear();
    let mesAnio = `${meses[mesNumero]} ${anioCompleto}`;
    //En csv sept se convierte en sep, así nos ahorramos ese problema
    if(mesAnio.split(' ')[0]=='sept'){
      mesAnio= mesAnio.replace('t','');
              }
    if (!(mesAnio in mesesUnicos)) {
      mesesUnicos[mesAnio] = 78.80;
    }

    fecha.setDate(1);
    fecha.setMonth(fecha.getMonth() + 1);
  }
  this.meses_unicos=mesesUnicos;
  const merged = { ...this.meses_unicos, ...this.ro_cogeneracion };
  console.log("Meses unicos: Histórico ", this.meses_unicos)
  console.log("merged: histórico ", merged)
  console.log("Ro: histórico : ", this.ro_cogeneracion)
  this.ro_cogeneracion=merged
},




async generarDatosDemandaHistorico() {
  console.log("Iniciando generación de datos históricos de demanda...");

  this.isLoading = true;
  this.mensaje_loading = "Generando datos de demanda...";

  await this.$nextTick();

  try {
    // Reiniciar los valores antes de generar nuevos datos
    /* this.demanda_vapor = [];
    this.demanda_frio = [];

    this.$emit("update:demanda_vapor", []);
    this.$emit("update:demanda_frio", []); */

    let datosVapor = [];
    let datosFrio = [];
    let contadorHora = 1;

    const valoresVaporBase = [
      60.948, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512, 61.512,
      62.078, 62.644, 62.644, 62.644, 63.766, 63.207, 62.644, 61.512,
      61.512, 62.644, 63.207, 63.766, 64.316, 64.857, 65.385, 65.385
    ];

    const valoresFrioBase = new Array(24).fill(2.50);

    // Obtener la fecha a partir de fechaActual
    const partes = this.configuracion.fechaActual.split("/");
    let start_date = new Date(partes[2], partes[1] - 1, partes[0]);
    
    start_date.setHours(0, 0, 0, 0); 

    // Determinar cuántos días generar 
    let total_dias;
    let total_horas
    let modoTexto = this.configuracion.modoEjecucionTexto?.toLowerCase();
    console.log("DEMANDA MODO TEXTO: ", modoTexto)
    if (modoTexto === "backtesting") {
      start_date.setDate(1);
      const mes_siguiente = new Date(start_date);
      mes_siguiente.setMonth(start_date.getMonth() + 1);
      const diferencia_en_milisegundos = mes_siguiente.getTime() - start_date.getTime();
      total_horas=diferencia_en_milisegundos / (1000 * 60 * 60);
      total_dias=total_horas/24
      console.log("Total de horas en demanda: ", total_horas)
    } else if (modoTexto === "planificación") {
      total_dias = this.configuracion.horizonte;
      //Revisar bisiestos
      total_horas = total_dias * 24;
    } else {
      total_dias = this.configuracion.horizonte || 1; // Valor por defecto seguro
      total_horas = total_dias * 24;
    }
    //this.configuracion.horizonte = total_dias;
    //this.$emit("update:configuracion", this.configuracion);

    
    let valoresVapor = new Array(Math.ceil(total_horas / valoresVaporBase.length)).fill(valoresVaporBase).flat().slice(0, total_horas);
    let valoresFrio = new Array(Math.ceil(total_horas / valoresFrioBase.length)).fill(valoresFrioBase).flat().slice(0, total_horas);
     if (this.demanda_vapor.length > 0 && this.demanda_vapor.length==8760) {           
            valoresVapor = this.demanda_vapor.map(obj => obj.valor);
           // console.log("Ya existen demandas de vapor: ",valoresVapor)
      }
      if (this.demanda_frio.length > 0 && this.demanda_vapor.length==8760){
              valoresFrio = this.demanda_frio.map(obj => obj.valor);
             // console.log("Ya existen demandas de frio: ",valoresFrio)
      }

    // Expandir valores de vapor y frío hasta cubrir todas las horas necesarias
    
    //console.log("A crear datos: ", total_horas)
    //console.log("long vapor: ",valoresVapor.length )
    //console.log("long frio: ",valoresFrio.length )
    for (let i = 0; i < total_horas; i++) {
      let fechaHora = new Date(start_date.getTime() + i * 60 * 60 * 1000);
      let horizonteStr = this.formatoFecha(fechaHora); 

      datosVapor.push({
        horizonte: horizonteStr,
        hora: `H${contadorHora}`,
        valor: valoresVapor[i]
      });

      datosFrio.push({
        horizonte: horizonteStr,
        hora: `H${contadorHora}`,
        valor: valoresFrio[i]
      });

      contadorHora++;
    }

    this.demanda_vapor = [...datosVapor];
    this.demanda_frio = [...datosFrio];

    this.$emit("update:demanda_vapor", this.demanda_vapor);
    this.$emit("update:demanda_frio", this.demanda_frio);
    //console.log(` Long vapor : ${this.demanda_vapor.length}   long frio: ${this.demanda_frio.length}`)
    console.log(` Demanda generada para ${total_dias} días (${total_horas} horas).`);
  } catch (error) {
    console.error("Error en la generación de demanda:", error);
    this.mensaje_loading = "Error al generar la demanda. Intenta nuevamente.";
  } finally {
    this.isLoading = false;
  }
},


  
    generarDisponibilidadHistorico() {
      console.log(" Generando disponibilidad desde histórico...");

      this.isLoading = true;
      this.mensaje_loading = "Cargando datos históricos...";

      this.$nextTick(() => {
        try {
          const partes = this.configuracion.fechaActual.split("/");
          let start_date = new Date(partes[2], partes[1] - 1, partes[0]);
          start_date.setHours(0, 0, 0, 0); 

          // Calcular el número correcto de días
          let total_dias;
          if (this.configuracion.modoEjecucion === 4) {
            total_dias = this.configuracion.horizonte;
          } else {
            const anio = start_date.getFullYear();
            const mes = start_date.getMonth() + 1;
            total_dias = new Date(anio, mes, 0).getDate();
          }

          console.log(` Generando datos desde ${this.formatoFecha(start_date).split(" ")[0]} por ${total_dias} días`);

          this.disponibilidad.cogeneracion = [];
          this.disponibilidad.caldera_gas = [];
          this.disponibilidad.caldera_electrica = [];

          this.$emit("update:disponibilidad", {
            cogeneracion: [],
            caldera_gas: [],
            caldera_electrica: []
          });

          let datosCogeneracion = [];
          let datosCalderaGas = [];
          let datosCalderaElectrica = [];
          let contadorHora = 1;

          /* const horasGeneradas = new Set(); */ // ← para evitar duplicados
          //console.log("Para disponibilidad ", this.horizonte_horas)
          for (let i = 0; i < this.horizonte_horas; i++) {
            let fechaHora = new Date(start_date.getTime() + i  * 60 * 60 * 1000);
              let horizonteStr = this.formatoFecha(fechaHora);
              //console.log("Fechas disponibilidad ", horizonteStr)
              /* if (horasGeneradas.has(horizonteStr)) {
                console.warn(" Hora duplicada detectada, saltando:", horizonteStr);
                continue;
              }
              horasGeneradas.add(horizonteStr); */


              datosCogeneracion.push({
                horizonte: horizonteStr,
                hora: `H${contadorHora}`,
                disponibilidad: {
                  "Motor cogeneración 1": 1,
                  "Motor cogeneración 2": 1,
                  "Motor cogeneración 3": 1,
                  "Motor cogeneración 4": 1,
                  "Motor cogeneración 5": 1,
                  "Motor cogeneración 6": 1,
                  "Motor cogeneración 7": 1,
                  "Motor cogeneración 8": 1
                }
              });

              datosCalderaGas.push({
                horizonte: horizonteStr,
                hora: `H${contadorHora}`,
                disponibilidad: {
                  "Caldera de gas 6": 1,
                  "Caldera de gas 7": 1,
                  "Caldera de gas 10": 1
                }
              });

              datosCalderaElectrica.push({
                horizonte: horizonteStr,
                hora: `H${contadorHora}`,
                disponibilidad: {
                  "Caldera eléctrica 1": 1,
                  "Caldera eléctrica 2": 1
                }
              });

              contadorHora++;
            
          }
          //console.log("Longitud: ", contadorHora)
          //console.log("Longitud generada: ", datosCogeneracion.length)
          this.disponibilidad.cogeneracion = [...datosCogeneracion];
          this.disponibilidad.caldera_gas = [...datosCalderaGas];
          this.disponibilidad.caldera_electrica = [...datosCalderaElectrica];

          this.$emit("update:disponibilidad", {
            cogeneracion: this.disponibilidad.cogeneracion,
            caldera_gas: this.disponibilidad.caldera_gas,
            caldera_electrica: this.disponibilidad.caldera_electrica
          });

          console.log(" Datos de disponibilidad generados correctamente.");
        } catch (error) {
          console.error(" Error en la generación de disponibilidad:", error);
          this.mensaje_loading = "Error al generar los datos. Intenta nuevamente.";
        } finally {
          this.isLoading = false;
        }
      });
    },



  
    async generarDisponibilidadPlanificacion() {
  console.log("Iniciando generación de disponibilidad para planificación...");

  this.isLoading = true;
  this.mensaje_loading = "Cargando planificación...";

  await this.$nextTick();

  try {
    // Obtener fecha base desde fechaActual (en formato dd/mm/yyyy)
    const partes = this.configuracion.fechaActual.split("/");
    let startDate = new Date(partes[2], partes[1] - 1, partes[0]);
    startDate.setHours(0, 0, 0, 0);

    // Determinar número de días según el modo
    let total_dias;
    let modoTexto = (this.configuracion.modoEjecucionTexto || "").trim().toLowerCase();
    console.log("disponibilidad MODO TEXTO:", modoTexto);

    if (modoTexto === "backtesting") {
      startDate.setDate(1); // primer día del mes
      const anio = startDate.getFullYear();
      const mes = startDate.getMonth() + 1;
      total_dias = new Date(anio, mes, 0).getDate(); // días del mes
    } else if (modoTexto === "planificación") {
      total_dias = this.configuracion.horizonte;
    } else {
      startDate.setDate(startDate.getDate() + 1); // saltar al día siguiente
      total_dias = this.configuracion.horizonte || 1;
    }

    

    // Reiniciar arrays de disponibilidad
    this.disponibilidad.cogeneracion = [];
    this.disponibilidad.caldera_gas = [];
    this.disponibilidad.caldera_electrica = [];

    this.$emit("update:disponibilidad", {
      cogeneracion: [],
      caldera_gas: [],
      caldera_electrica: []
    });

    const datosCogeneracion = [];
    const datosCalderaGas = [];
    const datosCalderaElectrica = [];
    let contadorHora = 1;
    const total_horas = total_dias * 24;
   
    for (let i = 0; i < total_horas; i++) {
      let fechaHora = new Date(startDate.getTime() + i * 60 * 60 * 1000);
      let horizonteStr = this.formatoFecha(fechaHora); 


        datosCogeneracion.push({
          horizonte: horizonteStr,
          hora: `H${contadorHora}`,
          disponibilidad: {
            "Motor cogeneración 1": 1,
            "Motor cogeneración 2": 1,
            "Motor cogeneración 3": 1,
            "Motor cogeneración 4": 1,
            "Motor cogeneración 5": 1,
            "Motor cogeneración 6": 1,
            "Motor cogeneración 7": 1,
            "Motor cogeneración 8": 1
          }
        });

        datosCalderaGas.push({
          horizonte: horizonteStr,
          hora: `H${contadorHora}`,
          disponibilidad: {
            "Caldera de gas 6": 1,
            "Caldera de gas 7": 1,
            "Caldera de gas 10": 1
          }
        });

        datosCalderaElectrica.push({
          horizonte: horizonteStr,
          hora: `H${contadorHora}`,
          disponibilidad: {
            "Caldera eléctrica 1": 1,
            "Caldera eléctrica 2": 1
          }
        });

        contadorHora++;
      
    }

    this.disponibilidad.cogeneracion = [...datosCogeneracion];
    this.disponibilidad.caldera_gas = [...datosCalderaGas];
    this.disponibilidad.caldera_electrica = [...datosCalderaElectrica];

    this.$emit("update:disponibilidad", {
      cogeneracion: this.disponibilidad.cogeneracion,
      caldera_gas: this.disponibilidad.caldera_gas,
      caldera_electrica: this.disponibilidad.caldera_electrica
    });

    console.log("Datos de disponibilidad para planificación generados correctamente.");
  } catch (error) {
    console.error("Error en la generación de disponibilidad:", error);
    this.mensaje_loading = "Error al cargar datos. Intenta nuevamente.";
  } finally {
    this.isLoading = false;
  }
},

 
  
    
  formatearMes(fecha) {
    if (!fecha) return "";
    // Si ya viene con guiones (ej. "jul-24") no se vuelve a formatear
    if (fecha.includes("-")) return fecha; 
    const [mes, anio] = fecha.split("/");
    const meses = {
      "01": "ene", "02": "feb", "03": "mar", "04": "abr", "05": "may", "06": "jun",
      "07": "jul", "08": "ago", "09": "sept", "10": "oct", "11": "nov", "12": "dic"
    };
    // Año con dos dígitos
    return `${meses[mes]}-${anio.slice(-2)}`;
  },
  accionEnCambioMesBacktesting(nuevoMes) {
      
      this.configuracion.mesBacktesting = this.formatearMes(nuevoMes);
      console.log("Mes Backtesting formateado:", this.configuracion.mesBacktesting);
      
      this.actualizarHorizonteConMes(this.configuracion.mesBacktesting);
    },
    accionEnCambioMesPlanificacion(nuevoMes) {
      
      this.configuracion.mesPlanificacion = this.formatearMes(nuevoMes);
      console.log("Mes Planificación formateado:", this.configuracion.mesPlanificacion);
      
      this.actualizarHorizonteConMes(this.configuracion.mesPlanificacion);
      // Llamar directamente a la función de generación
      this.generarPreciosPlanificacion();
    },
    
    actualizarHorizonteConMes(mesFormateado) {
      
      console.log("Actualizando horizontes con el mes:", mesFormateado);
      
      this.generarDatosRoCogeneracionHistorico();
      
    },
    
    generarPreciosPlanificacion() {
  const valores_elec2 = [
    117.02, 113.14, 112.38, 112.64, 112.58, 112.88, 116.84, 120.72,
    116.84, 112.82, 111.92, 98.00, 92.98, 92.79, 88.99, 83.00,
    81.80, 81.80, 94.37, 109.20, 117.60, 132.66, 125.50, 117.14,
    
  ];

  const partes = this.configuracion.fechaActual.split("/");
  const startDate = new Date(partes[2], partes[1] - 1, partes[0]);
  startDate.setHours(0, 0, 0, 0);

  const totalHoras = this.configuracion.horizonte * 24;
  const preciosElectricidad = [];
  const preciosGas = [];

  for (let i = 0; i < totalHoras; i++) {
    const fechaHora = new Date(startDate.getTime() + i * 60 * 60 * 1000);

    const fechaStr = this.formatoFecha
      ? this.formatoFecha(fechaHora) // si existe
      : `${fechaHora.getFullYear()}-${String(fechaHora.getMonth() + 1).padStart(2, "0")}-${String(fechaHora.getDate()).padStart(2, "0")} ${String(fechaHora.getHours()).padStart(2, "0")}:00`;

    const valorElec = valores_elec2[i % valores_elec2.length];
    const valorGas = 35.1; 

    preciosElectricidad.push({
      precio_estimado: valorElec,
      horizonte: fechaStr,
      hora: `H${i + 1}`
    });

    preciosGas.push({
      valor: valorGas,
      horizonte: fechaStr,
      hora: `H${i + 1}`
    });
  }

  this.elec_precios_manual = [...preciosElectricidad];
  this.gas_precios_manual = [...preciosGas];

  this.$emit("update:elec_precios_manual", this.elec_precios_manual);
  this.$emit("update:gas_precios_manual", this.gas_precios_manual);

  console.log("Precios planificados generados:", {
    electricidad: this.elec_precios_manual.length,
    gas: this.gas_precios_manual.length
  });
},



  obtenerMesAnioDesdeFechaActual() {
    const [, mes, anio] = this.configuracion.fechaActual.split("/").map(Number);
    const meses = {
        "01": "ene", "02": "feb", "03": "mar", "04": "abr", "05": "may", "06": "jun",
        "07": "jul", "08": "ago", "09": "sept", "10": "oct", "11": "nov", "12": "dic"
    };
    const mesTexto = meses[String(mes).padStart(2, "0")];
    const anioTexto = String(anio).slice(-2);
    return `${mesTexto}-${anioTexto}`;
},

  
  
  
  
  
  
    generarTituloEjecucionOperador() {
        const diasSemana = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
        const ahora = new Date();
  
        const diaSemana = diasSemana[ahora.getDay()];
        const dia = String(ahora.getDate()).padStart(2, '0');
        const mes = String(ahora.getMonth() + 1).padStart(2, '0');
        const año = ahora.getFullYear();
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
  
        return `Ejecución del ${diaSemana}. ${dia}-${mes}-${año} a las ${horas}h${minutos}m`;
    },
  
  
      // Lanzar simulacion
      async lanzar_simulacion() {
      
        if (this.vista_operador == true) {
          this.metadata.simulation_name = this.generarTituloEjecucionOperador();
        }

        if (!this.validarNombreSimulacion()) {
          return;
        }
        console.log("revisar disp")
        if (this.revisarDisponibilidades()) {
          return;
        }
  
  
        let datos_agregados = {}
        datos_agregados = this.agregar_datos(true)
  
      //const schema = this.validar_datos();
        //try {
          
          /*
          await schema.validate(datos_agregados, { 
              context: { anio_inicio: datos_agregados.anio_inicio, anio_fin: datos_agregados.anio_fin },
              abortEarly: false }
              );
          */     
          let msg_active=""   
          this.loading = false;
          //await this.obtener_lista_simulaciones();
          // Cambiar a usar FechaActual
          // const existeHoy = await this.hayOtroSeleccionadoHoy();
          const existeFechaActual= await this.hayOtroSeleccionadoFechaActual()
          //console.log("Este: ",this.configuracion.modoEjecucionTexto)
              if(this.configuracion.modoEjecucionTexto!='Planificación'&this.configuracion.modoEjecucionTexto!='Backtesting' & existeFechaActual.existe)
              {
                msg_active="Ya existe una simulación activa para el día "+existeFechaActual.fecha+" ."
  
              }
  
          this.errorMessage = null;        
          try {
            const result = await Swal.fire({
              title: "¿Estás seguro?<br>" + msg_active,
              text: "Esto lanzará la simulación con los datos actuales.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Sí, lanzar",
              cancelButtonText: "Cancelar",
            });
  
            if (result.isConfirmed) {
              this.loading = true;
  
              // Crear un archivo ZIP con JSZip
              const zip = new JSZip();
              zip.file("data.json", JSON.stringify(datos_agregados));
  
              // Generar el archivo ZIP en formato blob
              const zipBlob = await zip.generateAsync({ type: "blob" });
  
              // Crear un objeto FormData para enviar el archivo ZIP
              const formData = new FormData();
              formData.append("file", zipBlob, "data.zip");

              this.mensaje_loading = "Lanzando simulación... "
              // Enviar los datos al servidor            
              await axios({
                method: "post",
                url: process.env.VUE_APP_API_BASE_URL + "/api/lanzar-simulacion/",
                data: formData,
                withCredentials: true,
                headers: {
                  Authorization: "Bearer " + store.state.token,
                  "Access-Control-Allow-Origin": "*",
                  "Content-Type": "multipart/form-data",
                },
              });
                        
             

              // Mostrar mensaje de éxito
              Swal.fire("¡Simulación lanzada!", "La simulación se ha iniciado correctamente.", "success");
              this.$router.push('/'); //Nos vamos a la pagina de home
            }
          } catch (error) {
            console.error("Error al lanzar la simulación:", error);
            this.loading = false;
            // Mostrar mensaje de error
            if (error.response.status==601){
              Swal.fire("Error", "Hubo un problema al validar simulación", "error");
            }
            else{
              Swal.fire("Error", "Hubo un problema al lanzar la simulación.", "error");
            }
            
           
          }
          
  
  
        /*
        } catch (error) {
          // Maneja errores de validación
          this.errorMessage = error.inner.map((e) => e.message).join(", ");
          console.error("Errores de validación:", this.errorMessage);
          Swal.fire("Errores de validacion", this.errorMessage, "error");
        }
        */      
  
  
  
  
  
      },
  
      // Exportar la estructura de datos a disco
      exportData() {
        // Crear un archivo JSON para exportar los datos
        //const json = JSON.stringify(this.datos, null, 2); // Convertir `datos` a JSON con formato
        const json = JSON.stringify(this.agregar_datos(), null, 2); // Convertir `datos` a JSON con formato
  
        const blob = new Blob([json], { type: "application/json" }); // Crear un blob
        const url = URL.createObjectURL(blob); // Crear una URL de objeto
  
        // Crear un enlace temporal para descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = "datos.vis"; // Nombre del archivo
        link.click();
  
        // Liberar la URL de objeto después de usarla
        URL.revokeObjectURL(url);
      },
  
      // Importar la estructura de datos de disco
      importData() {
        // Crear un input para seleccionar un archivo
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "application/vis";
  
        // Leer el archivo seleccionado
        input.addEventListener("change", (event) => {
          const file = event.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const importedData = JSON.parse(e.target.result); // Parsear el JSON
                
                //this.datos = importedData; // Actualizar los datos
                this.desagregar_datos(importedData)
  
  
                console.log("Datos importados correctamente:", JSON.stringify(this.almacenamiento));
              } catch (err) {
                console.error("Error al importar JSON:", err);
                alert("El archivo no es válido o tiene un formato incorrecto.");
              }
            };
            reader.readAsText(file); // Leer el contenido del archivo como texto
          }
        });
  
        // Simular un clic en el input
        input.click();
      },
  
      // Descargar los resultados de la simulacion
      async descargar_resultados(){
          
  
           this.loading = true;
  
            await axios({
              method: 'get',
              url: process.env.VUE_APP_API_BASE_URL + '/api/descargar-resultado/' + this.id, // Ajusta la URL si es necesario
              responseType: 'blob', // Especifica que la respuesta es un archivo binario
              headers: { 
                Authorization: "Bearer " + store.state.token
              }
            })
              .then((response) => {    
                this.loading = false;
  
                // Crear un enlace para descargar el archivo ZIP
                const blob = new Blob([response.data], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
  
                // Crear un elemento <a> para simular la descarga
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'resultados-viscosim-' + this.id + '.zip'); // Nombre del archivo
                document.body.appendChild(link);
                link.click();
  
                // Limpiar el DOM
                link.remove();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                this.loading = false;
                console.error('Error al descargar el archivo:', error);
              });
  
  
  
  
      },
  
      // Obtener las entradas de la simulacion
      async obtener_entradas(id) {
            
  
            await axios({
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-entrada/" + id,
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob' // Asegura que recibimos un archivo binario
            })
            .then((response) => {
                this.loading = false;
  
                // Crear un objeto FileReader para leer el blob
                const fileReader = new FileReader();
  
                fileReader.onload = (event) => {
                    const arrayBuffer = event.target.result;
  
                    // Usar JSZip para descomprimir el archivo
                    JSZip.loadAsync(arrayBuffer).then((zip) => {
                        // Asumimos que el archivo JSON está en la raíz del ZIP
                        const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));
  
                        if (fileName) {
                            zip.file(fileName).async("string").then((jsonContent) => {
                                
                                //console.log(JSON.stringify(jsonContent))
                                //this.datos = JSON.parse(jsonContent);
                                this.desagregar_datos(JSON.parse(jsonContent));

                                //console.log(this.rows);
                            }).catch((err) => {
                                console.error("Error leyendo el archivo JSON del ZIP:", err);
                            });
                        } else {
                            console.error("No se encontró un archivo JSON en el ZIP.");
                        }
                    }).catch((err) => {
                        console.error("Error descomprimiendo el archivo ZIP:", err);
                    });
                };
  
                // Leer el blob como ArrayBuffer
                fileReader.readAsArrayBuffer(response.data);
            })
            .catch((error) => {
                this.loading = false;
                console.error("Error al obtener los precios:", error);
            });
      },
  
      // Validar los datos antes de enviarlos
      validar_datos() {
  
        // Logica para validar los datos antes de mandarlos al API
        // Implementado con YUP 
  
  
      },
  
      // Agregar los datos antes de enviarlos
      agregar_datos( lanzarSim=false) {
          let datos = {};
          datos['elec_peajes'] = this.elec_peajes;
          datos['elec_precios_manual'] = this.elec_precios_manual.slice(0,this.horizonte_horas);
          datos['elec_precios_OMIE'] = this.elec_precios_OMIE;
          datos['elec_precios_OMIE_QH']=this.elec_precios_OMIE_QH;
          datos['elec_precios_prevision'] = this.elec_precios_prevision;
          datos['elec_swap']=this.elec_swap;
          datos['demanda_vapor'] = this.demanda_vapor.slice(0, this.horizonte_horas);
          datos['demanda_frio'] = this.demanda_frio.slice(0, this.horizonte_horas);
          console.log("Longitudes antes de enviar:");
          console.log("demanda_vapor:", this.demanda_vapor.length);
          console.log("demanda_frio:", this.demanda_frio.length);
          console.log("horizonte:", this.configuracion.horizonte);
          datos['demanda_coef'] = this.demanda_coef;
          datos['configuracion'] = {
            ...this.configuracion,
            modoEjecucion: this.modoEjecucionTransformado(), 
            modoEjecucionTexto: this.configuracion.modoEjecucion === 4
              ? "Planificación"
              : this.configuracion.modoEjecucionTexto,
            generarSetsCuartohorarios: this.configuracion.modoEjecucion !== 4
          };
          datos['disponibilidad'] = this.disponibilidad;
          datos['acoplamiento_equipos'] = this.acoplamiento_equipos;
          datos['estadoAcoplamiento'] = this.estadoAcoplamiento;
          this.metadata["vista_operador"]=this.vista_operador;
          datos['metadata'] = this.metadata;
          datos['planta'] = this.planta;
          datos['resultado'] = this.resultado;
          datos['gas_precios_MIBGAS'] = this.gas_precios_MIBGAS;
          datos['gas_precios_manual'] = this.gas_precios_manual.slice(0,this.horizonte_horas);
          datos['gas_parametros']=this.gas_parametros;
          datos['gas_swap']=this.gas_swap;
          //SI es modo lanzar sim se filtran los meses necesarios
          if(lanzarSim){
            datos['ro_cogeneracion'] = Object.fromEntries(
              Object.entries(this.ro_cogeneracion)
            )
            console.log("datos introducidos: ", datos['ro_cogeneracion'])
          }
          //Si es modo guardar caso base, se guardan todas las entradas, revisando que estén en buen formato
          else{
            // Normalizar los horizontes de ro_cogeneracion
            datos['ro_cogeneracion'] = Object.fromEntries(
            Object.entries(this.ro_cogeneracion).map(([clave, valor]) => {
              // Clonar solo si es necesario
              if (
                valor &&
                typeof valor === 'number' &&
                /^[a-z]{3}-\d{2}$/i.test(clave)
              ) {
                const [mes, anio] = clave.split('-');
                clave = `${mes} 20${anio}`;
              }

              return [clave, valor]; // clave: valor directamente
            })
          );
          console.log("Lo que se guarda: ", datos['ro_cogeneracion'])
          }
          
          return datos;
      },
      
      // Desagregar los datos cuando los recibimos del servidor
      desagregar_datos(datos,hoy=false) {
        console.log("Valores omie desagregados: ", datos['elec_precios_OMIE'])
         const modoOriginal = datos['configuracion'].modoEjecucion;
        console.log("PRE Cantidad de deshabilitados: ", this.deshabilitar_generacion)
          if(this.configuracion.horizonte!=datos['configuracion']['horizonte'] ) {console.log ("Horizonte desigual");this.deshabilitar_generacion+=1}
          console.log("Cantidad de deshabilitados horizonte: ", this.deshabilitar_generacion)
          if(this.configuracion.modoEjecucionTexto !=datos['configuracion']['modoEjecucionTexto']) {console.log ("modoEjecucion desigual");this.deshabilitar_generacion+=1}
          console.log("Cantidad de deshabilitados ModoEjec: ", this.deshabilitar_generacion)
          if(this.configuracion.fechaActual!=datos['configuracion']['fechaActual'] ){console.log ("fechaActual desigual"); this.deshabilitar_generacion+=1;}
      //if(this.configuracion.precios!=datos['configuracion']['precios']){console.log ("precios desigual"); this.deshabilitar_generacion+=1}
      console.log("Cantidad de deshabilitados: ", this.deshabilitar_generacion)
        if (hoy){
   
            this.configuracion.horizonte=datos['configuracion']['horizonte']
            this.configuracion.mesBacktesting=datos['configuracion']['mesBacktesting']
            this.configuracion.mesHabilitado=datos['configuracion']['mesHabilitado']
            this.configuracion.mesPlanificacion=datos['configuracion']['mesPlanificacion']
            this.configuracion.modoEjecucion = modoOriginal;
            this.configuracion.opciones_precios=datos['configuracion']['opciones_precios']
            this.configuracion.otros=datos['configuracion']['otros']
            this.configuracion.pestanas=datos['configuracion']['pestanas']
            this.configuracion.precios=datos['configuracion']['precios']
          

            this.elec_precios_OMIE=[]
            console.log("Obtenido el caso base, el omie es: ",this.elec_precios_OMIE)
            this.elec_precios_OMIE_QH=[]
          }else{
            Object.assign(this.configuracion, datos['configuracion']);
            console.log('Datos conf: ', datos['configuracion'])
            
            if (this.configuracion.modoEjecucionTexto === "Planificación") {
              this.configuracion.modoEjecucion = 4;
            } else if (this.configuracion.modoEjecucionTexto === "Backtesting") {
              this.configuracion.modoEjecucion = 3;
            }
            Object.assign(this.elec_precios_OMIE, datos['elec_precios_OMIE']);
            if ('elec_precios_OMIE_QH' in datos){
              Object.assign(this.elec_precios_OMIE_QH, datos['elec_precios_OMIE_QH']);
            }
          
          }
          //alert("Desagregando...")
          //alert(JSON.stringify(datos['demanda_coef']))
          Object.assign(this.elec_peajes, datos['elec_peajes']);
          Object.assign(this.elec_precios_manual, datos['elec_precios_manual']);
          
          Object.assign(this.elec_precios_prevision, datos['elec_precios_prevision']);
          Object.assign(this.elec_swap, datos['elec_swap']);
          console.log("Demanda antes: ", datos['demanda_vapor'])
          Object.assign(this.demanda_vapor, datos['demanda_vapor']);

          console.log("Demanda Despues: ", this.demanda_vapor)
          Object.assign(this.demanda_frio, datos['demanda_frio']);
          
          //Object.assign(this.demanda_coef, datos['demanda_coef']);
          this.demanda_coef = datos['demanda_coef']
          //Si es hoy significa que está llamado desde obtener_caso_base y se quiere el día de hoy
          //por lo que se guarda todo del caso base menos la fecha, que está en 31/03/2025
          
          
          Object.assign(this.disponibilidad, datos['disponibilidad']);
          Object.assign(this.acoplamiento_equipos, datos['acoplamiento_equipos']);
          Object.assign(this.estadoAcoplamiento, datos['estadoAcoplamiento']);
          Object.assign(this.metadata, datos['metadata']);
          Object.assign(this.planta, datos['planta']);
          Object.assign(this.resultado, datos['resultado']);
          Object.assign(this.gas_precios_MIBGAS, datos['gas_precios_MIBGAS']);
          Object.assign(this.gas_precios_manual, datos['gas_precios_manual']);
          Object.assign(this.gas_swap, datos['gas_swap']);
          console.log("Datos gas_parametros ", datos['gas_parametros'])
          Object.assign(this.gas_parametros, datos['gas_parametros']);
          // El horario laboral manda sobre usar_input, independientemente de lo que traiga el caso base
          
          console.log("Datos gas_parametros despues ",this.gas_parametros)
          Object.assign(this.ro_cogeneracion, datos['ro_cogeneracion']);
          Object.assign(this.meses_unicos, datos['ro_cogeneracion']); 
      },

  
      async descargar_in() {
  
          let datos_agregados = {}
          datos_agregados = this.agregar_datos(true)
           this.loading = true;
           this.mensaje_loading = "Creando simulación..."
  
            // Crear un archivo ZIP con JSZip
            const zip = new JSZip();
            zip.file("data.json", JSON.stringify(datos_agregados));
  
            // Generar el archivo ZIP en formato blob
            const zipBlob = await zip.generateAsync({ type: "blob" });
  
            // Crear un objeto FormData para enviar el archivo ZIP
            const formData = new FormData();
            formData.append("file", zipBlob, "data.zip");
  
            // Enviar los datos al servidor            
            await axios({
              method: "post",
              url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-in/",
              data: formData,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
              },
              responseType: 'blob' // Asegura que recibimos un archivo binario
            })
              .then((response) => {    
                this.loading = false;
  
                // Crear un enlace para descargar el archivo ZIP
                const blob = new Blob([response.data], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
  
                // Crear un elemento <a> para simular la descarga
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'IN.zip'); // Nombre del archivo
                document.body.appendChild(link);
                link.click();
  
                // Limpiar el DOM
                link.remove();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                this.loading = false;
                console.error('Error al descargar el archivo:', error);
              });                    
  
  
      },
  
  
    async muestra_mensaje_error(mensaje){
  
      /*
      let mensaje = ""
  
      if (fuente == "MIBGAS"){
        mensaje = this.$t('mensajes.precios_mibgas_no_disponible')
      }
      if (fuente == "OMIE"){
        mensaje = this.$t('mensajes.precios_omie_no_disponible')
      }
      */
  
      Swal.fire({
                        title: this.$t('mensajes.se_produjo_un_problema'),
                        html: `
                          <div style="text-align: center;">
                            <p style="margin-bottom: 20px;"> ` + mensaje +
                            `</p> <!-- Mensaje personalizado -->
                            <div 
                              id="lottie-container" 
                              style="
                                width: 250px; 
                                height: 250px; 
                                margin: auto; 
                                overflow: hidden;">
                            </div>
                          </div>
                        `,            
                        //icon: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: this.$t('comun.boton_ok'),
  
                        didOpen: () => {
                          // Renderizar la animación Lottie
                          /*
                          lottie.loadAnimation({
                            container: document.getElementById("lottie-container"), // ID del contenedor
                            renderer: "svg",
                            loop: true,
                            autoplay: true,
                            path: "/viscosim-error.json", // Ruta del archivo JSON
                          });
                          */
  
                          const animation = lottie.loadAnimation({
                            container: document.getElementById("lottie-container"),
                            renderer: "svg",
                            loop: false, // No activamos loop global
                            autoplay: false, // Controlaremos la reproducción manualmente
                            path: "/viscosim-error.json",
                          });
  
                          // Reproducir del 0 al 140 primero
                          animation.addEventListener("DOMLoaded", () => {
                            animation.playSegments([0, 140], true);
                          });
  
                          // Al completar, hacer loop desde el 70 al 140
                          animation.addEventListener("complete", () => {
                            animation.playSegments([70, 140], true);
                            animation.loop = true; // Loop desde 70 hasta 140
                          });
  
  
                        },            
                      });
    },
  
  
  calcula_fechas() {
    let fecha = {};
  
    // Obtener la fecha actual y el horizonte desde la configuración
    let [dia, mes, anio] = this.configuracion.fechaActual.split('/').map(Number);
    let horizonte = this.configuracion.horizonte;
  
    // Crear objeto Date correctamente (año, mes - 1, día) y ajustar horas a medianoche
    let fechaActual = new Date(anio, mes - 1, dia);
    fechaActual.setHours(0, 0, 0, 0);
  
    // Calcular start_date y end_date
    let startDate = new Date(fechaActual);
    let endDate = new Date(fechaActual);
    
    startDate.setDate(startDate.getDate() + 1);
    endDate.setDate(endDate.getDate() + 1 + horizonte -1);
    
    //alert(fechaActual)
    //alert(startDate)
    //alert(horizonte)
    //alert(endDate)
  
    // Formatear a 'YYYY-MM-DD' evitando desfases horarios
    const formatoFecha = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    fecha['start_date'] = formatoFecha(startDate);
    fecha['end_date'] = formatoFecha(endDate);
  
    //alert(this.configuracion.fechaActual);
    //alert(JSON.stringify(fecha));
  
    return fecha;
  },
  //Función para actualizar el horizonte, es decir el string de la fecha+hora de una estructura de datos, como podría ser demanda_vapor
  fillFechas(matrix){

    let partes = this.configuracion.fechaActual.split("/");
        const fechaBase = new Date(partes[2], partes[1] - 1, partes[0]);
        fechaBase.setDate(fechaBase.getDate()+1);
        fechaBase.setHours(0,0,0,0);
        matrix.forEach((item,index) => {
          let fechaHora = new Date(fechaBase.getTime());
          fechaHora.setHours(fechaHora.getHours() + index);
          item.horizonte = this.formatoFecha(fechaHora);  // Añadimos la clave 'hora' con el formato 'H0', 'H1', 'H2
        });
  },
  
  
      fillHours(matrix){
        matrix.forEach((item,index) => {
          item.hora = 'H' + (index+1);  // Añadimos la clave 'hora' con el formato 'H0', 'H1', 'H2
        });
      },
      formatearFechasCampo(array, campo = 'fecha_hora') {
        return array.map(p => {
          const date = new Date(p[campo]);
          const dia = String(date.getDate()).padStart(2, '0');
          const mes = String(date.getMonth() + 1).padStart(2, '0');
          const anio = date.getFullYear();
          const horas = date.getHours().toString().padStart(2, '0');
          const minutos = date.getMinutes().toString().padStart(2, '0');

          return {
            ...p,
            [campo]: `${dia}-${mes}-${anio} ${horas}:${minutos}`,
          };
        });
      },

  
      // Descargar los precios de OMIE
async descargar_precios_omie() {
  console.log("Llamando a descargar_precios_omie")
  //console.log("DESCARGANDO PRECIOS DE OMIE:", this.configuracion.fechaActual.split("/").map(Number) )
  try {
    let response;
    console.log("Antes de descargar Omie, el valor es: ", this.elec_precios_OMIE)
    if (this.configuracion.modoEjecucionTexto === "Backtesting") {
      //  Si estamos en Backtesting, descargar precios históricos usando `fechaActual`
      console.log(" Descargando precios históricos de OMIE...");

      if (!this.configuracion.fechaActual) {
        console.error(" No hay fechaActual definida.");
        return;
      }


      const [, mes, anio] = this.configuracion.fechaActual.split("/").map(Number);
      const mesStr = String(mes).padStart(2, "0");
      const anioStr = String(anio);

      const start_date = `${anioStr}-${mesStr}-01`;
      const end_date = new Date(anio, mes, 0).toISOString().split("T")[0];

      response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-omie-historicos?start_date=${start_date}&end_date=${end_date}`,
        {
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Content-Type": "application/json"
          }
        }
      );
    } else {
      // Si no es Backtesting, descargar precios actuales
      console.log("Descargando precios normales de OMIE...");
      let fecha = this.calcula_fechas();

      response = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-omie?start_date=${fecha.start_date}&end_date=${fecha.end_date}`,
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + store.state.token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        }
      });
    }

    // Guardar los datos en elec_precios_OMIE
    if (response.status === 200 && Array.isArray(response.data)) {
      if (response.data.length === 0) {
        console.warn(" No se encontraron precios de OMIE");
        await this.muestra_mensaje_error(this.$t("mensajes.precios_omie_no_disponible"));
      } else {
        console.log("Datos Omie: ", response.data.length)
        this.elec_precios_OMIE = response.data.map((registro, index) => ({
          ...registro,
          hora: `H${index + 1}`
        }));
      }
    } else {
      throw new Error(" La respuesta de la API no es válida");
    }
  } catch (error) {
    console.error(" Error al descargar precios OMIE:", error);
    await this.muestra_mensaje_error(this.$t("mensajes.precios_omie_no_disponible"));
    this.elec_precios_OMIE = [];
  } finally {
    this.$nextTick(() => {
      this.loading = false;
    });
  }
},

 // Descargar los precios de OMIE
async descargar_precios_omie_QH() {
  console.log("Llamando a descargar_precios_omie_QH")
  //console.log("DESCARGANDO PRECIOS DE OMIE:", this.configuracion.fechaActual.split("/").map(Number) )
  try {
    let response;
    console.log("Antes de descargar Omie, el valor es: ", this.elec_precios_OMIE_QH)
    if (this.configuracion.modoEjecucionTexto !== "Backtesting") {

      // Si no es Backtesting, descargar precios actuales
      console.log("Descargando precios normales de OMIE QH...");
      let fecha = this.calcula_fechas();

      response = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-omie-QH?start_date=${fecha.start_date}&end_date=${fecha.end_date}`,
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + store.state.token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        }
      });
    }

    // Guardar los datos en elec_precios_OMIE
    if (response.status === 200 && Array.isArray(response.data)) {
      if (response.data.length === 0) {
        console.warn(" No se encontraron precios de OMIE");
        await this.muestra_mensaje_error(this.$t("mensajes.precios_omie_no_disponible"));
      } else {
        console.log("Datos Omie QH: ", response.data)
        // this.elec_precios_OMIE_QH = response.data.map((registro, index) => ({
        //   ...registro,
        
        // }));
        this.elec_precios_OMIE_QH=response.data
      }
    } else {
      throw new Error(" La respuesta de la API no es válida");
    }
  } catch (error) {
    console.error(" Error al descargar precios OMIE:", error);
    this.elec_precios_OMIE_QH = [];
  } finally {
    this.$nextTick(() => {
      this.loading = false;
    });
  }
},


  
  
      // Descargar los precios de MIBGAS
async descargar_precios_mibgas() {
  this.loading = true;
  try {
    let response;

    if (this.configuracion.modoEjecucionTexto === "Backtesting") {
      //  Descargar precios históricos de MIBGAS usando fechaActual
      console.log(" Descargando precios históricos de MIBGAS...");

      if (!this.configuracion.fechaActual) {
        console.error(" No hay fechaActual definida.");
        return;
      }

      const [, mes, anio] = this.configuracion.fechaActual.split("/").map(Number);
      const mesStr = String(mes).padStart(2, "0");
      const anioStr = String(anio);

      const start_date = `${anioStr}-${mesStr}-01`;
      const end_date = new Date(anio, mes, 0).toISOString().split("T")[0];

      response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-mibgas-historicos?start_date=${start_date}&end_date=${end_date}`,
        {
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Content-Type": "application/json"
          }
        }
      );
    } else {
      //  Si no es Backtesting, usar las fechas actuales
      console.log("Descargando precios normales de MIBGAS...");
      let fecha = this.calcula_fechas();

      response = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-mibgas?start_date=${fecha.start_date}&end_date=${fecha.end_date}`,
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + store.state.token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        }
      });
    }

    //  Guardar los datos en gas_precios_MIBGAS
    if (response.status === 200 && Array.isArray(response.data)) {
      if (response.data.length === 0) {
        console.warn(" No se encontraron precios de MIBGAS");
        await this.muestra_mensaje_error(this.$t("mensajes.precios_mibgas_no_disponible"));
      } else {
      console.log("Respuesta: ", response.data)
        this.gas_precios_MIBGAS = response.data.map((registro, index) => ({
          ...registro,
          hora: `H${index + 1}`
        }));
      }
    } else {
      throw new Error(" La respuesta de la API no es válida");
    }

  } catch (error) {
    console.error(" Error al descargar precios de MIBGAS:", error);
    await this.muestra_mensaje_error(this.$t("mensajes.precios_mibgas_no_disponible"));
    this.gas_precios_MIBGAS = [];
  } finally {
    this.$nextTick(() => {
      this.loading = false;
    });
  }
},




      /*async descargar_precios_omie_historicos() {
        try {
          if (!this.configuracion.mesBacktesting) {
            console.error("No hay mes de Backtesting seleccionado");
            return;
          }
  
          // Convertimos "jul-24" a "2024-07"
          let [mesTexto, anioTexto] = this.configuracion.mesBacktesting.split("-");
          const meses = {
            "ene": "01", "feb": "02", "mar": "03", "abr": "04", "may": "05", "jun": "06",
            "jul": "07", "ago": "08", "sept": "09", "oct": "10", "nov": "11", "dic": "12"
          };
  
          const mes = meses[mesTexto];
          const anio = `20${anioTexto}`;
  
          if (!mes || isNaN(parseInt(anio))) {
            console.error("Formato de mesBacktesting incorrecto:", this.configuracion.mesBacktesting);
            return;
          }
  
          let start_date = `${anio}-${mes}-01`;
          let end_date = new Date(parseInt(anio), parseInt(mes), 0).toISOString().split("T")[0];
  
          console.log("Descargando precios históricos de OMIE...");
          this.loading = true;
          this.mensaje_loading = "Descargando precios históricos de OMIE...";
  
          const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-omie-historicos?start_date=${start_date}&end_date=${end_date}`,
            {
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Content-Type": "application/json"
              }
            }
          );
  
          if (response.status === 200 && Array.isArray(response.data)) {
            if (response.data.length === 0) {
              console.warn("No se encontraron precios históricos de OMIE");
              await this.muestra_mensaje_error(this.$t("mensajes.precios_omie_no_disponible"));
            } else {
              // Asignamos los datos al final, asegurando que loading no se detiene antes
              this.elec_precios_OMIE = response.data.map((registro, index) => ({
                ...registro,
                hora: `H${index + 1}`
              }));
            }
          } else {
            throw new Error("La respuesta de la API no es válida");
          }
  
        } catch (error) {
          console.error("Error al descargar precios históricos de OMIE:", error);
          await this.muestra_mensaje_error(this.$t("mensajes.precios_omie_no_disponible"));
          this.elec_precios_OMIE = [];
        } finally {
          
          this.$nextTick(() => {
            this.loading = false;
          });
        }
  },*/
  
  
  
      /*async descargar_precios_mibgas_historicos() {
        try {
            if (!this.configuracion.mesBacktesting) {
                console.error("No hay mes de Backtesting seleccionado");
                return;
            }
  
            // Convertimos "jul-24" a "2024-07"
            let [mesTexto, anioTexto] = this.configuracion.mesBacktesting.split("-");
            const meses = {
                "ene": "01", "feb": "02", "mar": "03", "abr": "04", "may": "05", "jun": "06",
                "jul": "07", "ago": "08", "sept": "09", "oct": "10", "nov": "11", "dic": "12"
            };
  
            const mes = meses[mesTexto];
            const anio = `20${anioTexto}`;
  
            if (!mes || isNaN(parseInt(anio))) {
                console.error("Formato de mesBacktesting incorrecto:", this.configuracion.mesBacktesting);
                return;
            }
  
            // Definir `start_date` y `end_date` para el mes seleccionado
            let start_date = `${anio}-${mes}-01`; // Primer día del mes
            let end_date = new Date(parseInt(anio), parseInt(mes), 0).toISOString().split("T")[0]; // Último día del mes
  
            console.log("Descargando precios históricos de MIBGAS:", start_date, "hasta:", end_date);
  
            // Activar loader
            this.loading = true;
            this.mensaje_loading = "Descargando precios históricos de MIBGAS...";
  
            const response = await axios.get(
                `${process.env.VUE_APP_API_BASE_URL}/api/descargar-precios-mibgas-historicos?start_date=${start_date}&end_date=${end_date}`,
                {
                    withCredentials: true,
                    headers: {
                        Authorization: "Bearer " + store.state.token,
                        "Content-Type": "application/json"
                    }
                }
            );
  
            if (response.status === 200 && Array.isArray(response.data)) {
            // **Agregar la columna `hora`** en el padre
            this.gas_precios_MIBGAS = response.data.map((registro, index) => ({
              ...registro,
              hora: `H${index + 1}` // Agregar `H1`, `H2`, `H3`, ...
            }));
  
  
                if (this.gas_precios_MIBGAS.length === 0) {
                    console.warn("No se encontraron precios históricos de MIBGAS");
                    await this.muestra_mensaje_error(this.$t("mensajes.precios_mibgas_no_disponible"));
                }
            } else {
                throw new Error("La respuesta de la API no es válida");
            }
  
        } catch (error) {
            console.error("Error al descargar precios históricos de MIBGAS:", error);
            await this.muestra_mensaje_error(this.$t("mensajes.precios_mibgas_no_disponible"));
            this.gas_precios_MIBGAS = [];
        } finally {
            // Desactivar loader después de la descarga
            this.loading = false;
        }
    },*/
  
  
  
      // Descargar los precios de Simulart
      async descargar_precios_simulart(){
          
  
        try {
  
          let fecha = this.calcula_fechas()
  
          const response = await axios({
            method: 'get',
            url: process.env.VUE_APP_API_BASE_URL + '/api/descargar-precios-simulart?start_date=' + fecha['start_date'] + '&end_date=' + fecha['end_date'],
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            },
          });
          
          let myObject = response.data;
          this.elec_precios_prevision = myObject;
          
          if (this.elec_precios_prevision.length == 0){
            let mensaje = ""
            mensaje = this.$t('mensajes.precios_simulart_no_disponible')  
            await this.muestra_mensaje_error(mensaje)         
          } else{
            this.fillHours(this.elec_precios_prevision)
          }
  
    
        } catch (error) {
  
          alert(error);
          this.elec_precios_prevision = [];
  
        }
  
            
      },
  
  
  
  
      async accionEnCambioFecha(nuevaFecha) {
        if (this.deshabilitar_generacion>0){
          console.log("accionEnCambioFecha -=1 ",this.deshabilitar_generacion )
          this.deshabilitar_generacion-=1
          return
        }
        if (this.id == null) {
  
          console.log("se cambio la fecha a " + nuevaFecha)
          this.actualizar_horizonte_horas()
          this.configuracion.fechaActual = nuevaFecha
          //this.generarDatosRoCogeneracion(this.configuracion.horizonte);
          this.obtenerRo()
          this.generarDisponibilidad();
          this.generarAcoplamiento();
          this.generarDemandas();
          this.generarManuales()
  
  
  
          this.loading = true;
  
          if (this.configuracion.precios == "OMIE"){
            this.mensaje_loading = "Descargando precios de OMIE..."
            console.log("descargar precios_omie 1" )
            await this.descargar_precios_omie()      
            await this.descargar_precios_omie_QH()
          }
  
          if (this.configuracion.precios == "SimularT"){
            this.mensaje_loading = "Descargando precios de SimularT..."
            await this.descargar_precios_simulart()
          }
  
  
          this.mensaje_loading = "Descargando precios de MIBGAS..."
          await this.descargar_precios_mibgas()
  
          this.loading = false;
  
        }
  
  
  
      },
  
      async accionEnCambioHorizonte(nuevoHorizonte){
        this.actualizar_horizonte_horas()
        if (this.deshabilitar_generacion>0){
           console.log("accionEnCambioHorizonte -=1 ", this.deshabilitar_generacion, " -- ", nuevoHorizonte)
          this.deshabilitar_generacion-=1
          return
        }
  
        if (this.id == null) {
          console.log("Cambio Horizonte: ",nuevoHorizonte)
          //this.elec_precios_manual = Array(24 * nuevoHorizonte).fill(0);
          //this.gas_precios_manual = Array(24 * nuevoHorizonte).fill(35.1);
          // Cuando se cambia el precio o el horizonte en el hijo
          // alert("Se cambio el horizonte a " + nuevoHorizonte)
          // alert("Ahora vale: " + this.configuracion.horizonte)
          //this.generarDatosRoCogeneracion(nuevoHorizonte);
          this.obtenerRo()
          this.loading = true;
          //Los precios de omie siempre van a tener de horizonte 1, osea que realmente no se va a cambiar

         /*  if (this.configuracion.precios == "OMIE"){
            this.mensaje_loading = "Descargando precios de OMIE..."
            await this.descargar_precios_omie()      
          } */
  
          if (this.configuracion.precios == "SimularT"){
            this.mensaje_loading = "Descargando precios de SimularT..."
            await this.descargar_precios_simulart()
          }
  
          this.mensaje_loading = "Descargando precios de MIBGAS..."
          await this.descargar_precios_mibgas()
          this.loading = false;
  
        }
  
  
  
        
      },
  
      async accionEnCambioPrecio(nuevoPrecio){
        if (this.deshabilitar_generacion>0){
          console.log("accionEnCambioPrecio -=1 ", this.deshabilitar_generacion)
          this.deshabilitar_generacion-=1
          return
        }
        //this.generarDatosRoCogeneracion(this.configuracion.horizonte);
        this.obtenerRo()
        alert("Se cambio el precio a " + nuevoPrecio)
      },
  
  
      // Obtener las entradas de la simulacion
      async obtener_programa(id) {
  
          const response =  await axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + "/api/programa/" + id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )        
          let myObject = response.data;
          this.programa = myObject            
      },
  
      async obtener_resultado_operacion(id) {
  
          const response =  await axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + "/api/resultado-operacion/" + id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )        
          let myObject = response.data;
          this.resultado_operacion = myObject            
      },
  
      async obtener_resultado_economico(id) {
  
          const response =  await axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + "/api/resultado-economico/" + id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )        
          let myObject = response.data;
          this.resultado_economico = myObject            
      },
  
      async obtener_resultados(id) {
  
          const response =  await axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + "/api/resultados/" + id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )        
          let myObject = response.data;
          console.log("Resultado recibido:", myObject);
          this.resultados = myObject            
      },
  
  
  
      async obtener_caso_base() {
        try {
            const response = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-caso-base/",
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob' // Recibimos un archivo binario
            });
  
            // Promisificar FileReader
            const arrayBuffer = await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.onload = () => resolve(fileReader.result);
                fileReader.onerror = () => reject(new Error("Error leyendo el archivo"));
                fileReader.readAsArrayBuffer(response.data);
            });
  
            // Descomprimir con JSZip
            const zip = await JSZip.loadAsync(arrayBuffer);
            const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));
  
            if (!fileName) {
                console.error("No se encontró un archivo JSON en el ZIP.");
                return;
            }
  
            const jsonContent = await zip.file(fileName).async("string");
            this.desagregar_datos(JSON.parse(jsonContent),true);
            this.gas_parametros.usar_input = esHorarioLaboral() ? 1 : 0;          
            //console.log("Caso base:",this.rows);
  
        } catch (err) {
            console.error("Error en obtener_caso_base:", err);
        }
      },
  
  
  
      async guardar_caso_base() {
  
  
          const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Esto actualizará el caso base con los datos actuales.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, actualizar",
            cancelButtonText: "Cancelar",
          });
  
          if (result.isConfirmed) {
            this.loading = true;
  
            let datos_agregados = {}
            datos_agregados = this.agregar_datos()
            datos_agregados['metadata']['simulation_name']="Sin título"
            //No se guardan los datos de omie en el caso base
            datos_agregados['elec_precios_OMIE']=[]
            this.loading = true;
            this.mensaje_loading = "Actualizando caso base"
  
            // Crear un archivo ZIP con JSZip
            const zip = new JSZip();
            zip.file("data.json", JSON.stringify(datos_agregados));
  
            // Generar el archivo ZIP en formato blob
            const zipBlob = await zip.generateAsync({ type: "blob" });
  
            // Crear un objeto FormData para enviar el archivo ZIP
            const formData = new FormData();
            formData.append("file", zipBlob, "data.zip");
            
            // Enviar los datos al servidor            
            await axios({
              method: "post",
              url: process.env.VUE_APP_API_BASE_URL + "/api/cargar-caso-base/",
              data: formData,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
              },
              responseType: 'blob' // Asegura que recibimos un archivo binario
            })
            this.loading = false;
          }
  
      },
      //Función que activa la simulación, cambiandole el estado
      async activarSimulacion(){
        this.showAlertActive=false;
        this.showAlert=false;
        // localValid pasa a 1 solo cuando actualizar_estado confirma que no hay otra activa (a posteriori)
        await this.actualizar_estado(this.id, true);
      },
      //Función que indica que NO hay ninguna simulación seleccionada para la fecha de la simulación pasada por id
      //Formatea una fecha (Date o string) a "%d-%m-%Y", el formato que espera /api/validez-dia
      aDMY(fecha){
        const d = new Date(fecha);
        if (isNaN(d)) return null;
        const dd = String(d.getDate()).padStart(2,'0');
        const mm = String(d.getMonth()+1).padStart(2,'0');
        return `${dd}-${mm}-${d.getFullYear()}`;
      },
      //Devuelve el día ("%d-%m-%Y") de una simulación de la lista
      //Usa START_DATE_SIMULATION
      diaSimulacion(idSeleccionado){
        const lista = Array.isArray(this.lista_simulaciones) ? this.lista_simulaciones : [];
        const obj = lista.find(o => o.id === parseInt(idSeleccionado)) || lista.find(o => o.id === idSeleccionado);
        if (!obj) return null;
        if (obj.START_DATE_SIMULATION) return obj.START_DATE_SIMULATION.slice(0,10);
        return this.aDMY(obj.created);
      },
      //Helper: pregunta al backend si hay una simulación válida en un día (/api/validez-dia)
      async consultarValidezDia(dia, excluir_id = null){
        try {
          let url = process.env.VUE_APP_API_BASE_URL + '/api/validez-dia?dia=' + encodeURIComponent(dia);
          if (excluir_id != null) url += '&excluir_id=' + encodeURIComponent(excluir_id);
          const response = await axios({
            method: 'get',
            url,
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            },
          });
          return response.data || { existe: false, fecha: dia };
        } catch (e) {
          console.error("Error consultando validez del día:", e);
          return { existe: false, fecha: dia };
        }
      },
      //¿Hay alguna válida ese día (incluida la propia)? (lo calcula el backend)
      async NoHayOtroSeleccionado(idSeleccionado) {
        const dia = this.diaSimulacion(idSeleccionado);
        if (!dia) return { existe: false, fecha: null };
        console.log("NoHayOtroSeleccionado DIA-> ",dia)
        return await this.consultarValidezDia(dia);
      },
      //¿Hay ya una simulación válida hoy para mañana? (lo calcula el backend)
      async hayOtroSeleccionadoHoy() {
         const manana = new Date();
        manana.setDate(manana.getDate() + 1);
        const dia = this.aDMY(manana);
    
        console.log("hayOtroSeleccionadoHoy DIA-> ",dia)
        return await this.consultarValidezDia(dia);
      },
      //¿Hay ya una simulación válida el día de configuracion.fechaActual? (lo calcula el backend)
      //fechaActual viene como "dd/mm/yyyy" (toLocaleDateString es-ES); la API espera "dd-mm-yyyy".
      //No se pasa por new Date(): interpretaría el primer número como mes (formato americano).
      async hayOtroSeleccionadoFechaActual() {
        let dia = (this.configuracion.fechaActual || "").replace(/\//g, "-");
        if (!dia) return { existe: false, fecha: null };
        //Fuera de Backtesting/Planificación la simulación empieza al día siguiente de fechaActual
        const modoTexto = this.configuracion.modoEjecucionTexto;
        if (modoTexto !== "Backtesting" && modoTexto !== "Planificación") {
          const [dd, mm, yyyy] = dia.split("-").map(Number);
          const fecha = new Date(yyyy, mm - 1, dd);
          fecha.setDate(fecha.getDate() + 1);
          dia = this.aDMY(fecha);
        }
        console.log("hayOtroSeleccionadoFechaActual DIA-> ", dia);
        return await this.consultarValidezDia(dia);
      },


       //¿Hay OTRA simulación válida el mismo día que `idSeleccionado`? (lo calcula el backend)
       async hayOtroSeleccionado(idSeleccionado) {
        const dia = this.diaSimulacion(idSeleccionado);
        if (!dia) return { existe: false, fecha: null };
        console.log("hayOtroSeleccionado DIA-> ",dia)
        return await this.consultarValidezDia(dia, idSeleccionado);
      },
      //Funcion replicada de ComponenteSimulaciones, para cambiar el estado de válido
       async actualizar_estado(id, valid){
        console.log("Actualizar con ", id, " y con: ", valid)
        console.log("Sims: ", this.lista_simulaciones)
          this.loading = true;
          this.mensaje_loading = this.$t('simulaciones.actualizando')
          let new_status = 0;
          const hayMasSeleccionado=await this.hayOtroSeleccionado(id)
          if (valid == true){
            new_status = 1;
            if (hayMasSeleccionado.existe){
              this.error_msg=this.$t('simulaciones.error_sim_duplicada', { fecha: hayMasSeleccionado.fecha });+"."
              this.showAlert=true;
              this.loading = false;
              const encontrado = this.lista_simulaciones.find(obj => obj.id === parseInt(id));
              encontrado.VALID=0;
              this.localValid=0
              return;
            }
          } else {
            new_status = 0;
            if (!hayMasSeleccionado.existe){
              this.error_msg= this.$t('simulaciones.error_sim_valida', { fecha: hayMasSeleccionado.fecha });+"."
              this.showAlert=true;
              
            }
          }         
            
          //console.log("Estado de simulaciones: ",id ," --- ",this.lista_simulaciones)               
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/cambiar-estado?simulation_id=' + id + '&new_status=' + new_status ,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then(() => {                 
              this.loading = false;
              // Ya confirmado que no había otra activa, se cambia al nuevo estado
              this.localValid = new_status;
          })
      },
    /* verificarIncompatibilidades(disponibilidad, acoplamiento, estadoAcoplado) {
  if (!(this.configuracion.modoEjecucion === 2 || this.configuracion.modoEjecucion === '3')) return false;

  const motores = [...Array(8)].map((_, i) => `Motor cogeneración ${i + 1}`);
  const incompatibilidades = new Set();

  for (let i = 0; i < acoplamiento.length; i++) {
    const filaAcop = acoplamiento[i];
    const filaDisp = disponibilidad[i];
    if (!filaAcop || !filaDisp) continue;

    for (let j = 0; j < motores.length; j++) {
      const motor = motores[j];
      const estaAcoplado = estadoAcoplado?.[j] === 'Si';
      const acopVal = filaAcop.acoplamiento?.[motor] ?? 0;
      const dispVal = filaDisp.disponibilidad?.[motor] ?? 1;

      if (estaAcoplado && acopVal > 0 && dispVal === 0) {
        incompatibilidades.add(motor);
      }
    }
  }

  if (incompatibilidades.size > 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Incompatibilidad detectada',
      html: `
        <p>Por favor, revisar compatibilidad de disponibilidades y acoplamientos fijados.</p>
        <p><strong>Motor(es):</strong> ${[...incompatibilidades].join(', ')}</p>
      `,
      confirmButtonText: 'Entendido'
    });
    return true;
  }

  return false;
}*/


   async accederPrecios() {
      // 1. Resetear estado y mostrar un loader si fuera necesario
      this.acceso_concedido = false;

      try {
        const response = await axios({
          method: 'get',
          url: `${process.env.VUE_APP_API_BASE_URL}/api/permiso/recurso`,
          params: { 
            user_name: store.state.usuarioNombre, 
            resource: "precios" 
          },
          withCredentials: true,
          headers: { 
            Authorization: `Bearer ${store.state.token}`,
          },
        });

        // 2. Supongamos que tu API responde con { tieneAcceso: true/false }
        // Ajusta 'response.data.acceso' según la estructura real de tu JSON
        //alert(JSON.stringify(response.data))
        if (response.data.access_level == 'EDITABLE') {
          this.acceso_concedido = true;
          this.configuracion.precios = "Manual";
          
          // Notificación pequeña (Toast) para no interrumpir
          Swal.fire({
            icon: 'success',
            title: 'Acceso verificado',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
        } else {
          this.acceso_concedido = false;
          
          Swal.fire({
            title: 'Acceso Denegado',
            text: response.data.message,
            icon: 'warning',
            confirmButtonText: 'Entendido'
          });
        }

      } catch (error) {
        console.error("Error al verificar acceso:", error);
        this.acceso_concedido = false;

        Swal.fire({
          title: 'Error de conexión',
          text: 'No pudimos verificar tus permisos. Revisa tu conexión a internet.',
          icon: 'error',
          confirmButtonText: 'Reintentar'
        });
      }
    },

    async solicitarAcceso() {
      const datos = {
        resource: "precios",
        user_name: store.state.usuarioNombre
      };

      try {
        const response = await axios({
          method: 'post',
          url: `${process.env.VUE_APP_API_BASE_URL}/api/permiso/solicitud`,
          withCredentials: true,
          headers: { 
            Authorization: `Bearer ${store.state.token}`,
            // 'Access-Control-Allow-Origin' no se debe enviar desde el cliente, es una cabecera de servidor.
          },
          data: datos
        });

        console.log("Respuesta:", response.data);

        // SweetAlert2 con mejor diseño
        Swal.fire({
          title: '¡Solicitud enviada!',
          text: 'Hemos registrado tu petición. Recibirás una notificación por correo electrónico en cuanto el administrador autorice tu acceso.',
          icon: 'success',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
          timer: 5000, // Se cierra solo tras 5 segundos si no interactúan
          timerProgressBar: true
        });

      } catch (error) {
        console.error("Error al solicitar acceso:", error);
        
        Swal.fire({
          title: 'Error',
          text: 'No se pudo procesar la solicitud en este momento. Por favor, inténtalo más tarde.',
          icon: 'error',
          confirmButtonText: 'Cerrar'
        });
      }
    }


    },
  
  
  
    async mounted(){
      //Es una caso de estudio con simulación terminada
      if (this.id != null){
        // La lista solo se usa en esta vista (diaSimulacion / actualizar_estado);
        // en una nueva simulación no hace falta y retrasaba el arranque
        await this.obtener_lista_simulaciones();
        //console.log("Leer entradas")
        //console.log("Leer resultados")
        this.loading = true;
        this.mensaje_loading = this.$t('simulaciones.obteniendo_programa', { id: this.id });
        await this.obtener_programa(this.id)
        await this.obtener_entradas(this.id)
        this.mensaje_loading = this.$t('simulaciones.obteniendo_resultados', { id: this.id });
        await this.obtener_resultados(this.id)
        console.log("Después de obtener_resultados → Horizonte:", this.configuracion.horizonte)
        
        // Mantener el loading activo mientras se resuelven las comprobaciones de validez
        this.loading = true;
        const existeActiva=await this.hayOtroSeleccionado(this.id)
        const noExisteActiva=await this.NoHayOtroSeleccionado(this.id)
        //Para deshabilitar horizonte si hace falta
        if (this.vista_operador == false){
          this.$refs.ComponenteConf.actualizarHorizonte(this.configuracion.precios);
        }
        this.loading = false;
        //Ver si es válida la simulación
        if (existeActiva.existe){
          //console.log(this.hayOtroSeleccionado(this.id))
          this.error_msg=this.$t('simulaciones.error_otras_activas', { fecha: existeActiva.fecha });
          this.showAlert=true
        }
        if(!noExisteActiva.existe){
          this.error_msg=this.$t('simulaciones.error_ninguna_activa', { fecha: noExisteActiva.fecha });
          this.showAlert=true
          this.showAlertActive=true
        }
        
      } else {

        //Es una nuevo caso de estudio
        
        this.loading = true;
        const fecha = new Date();
        fecha.setDate(fecha.getDate()); 
        //Al asignar la fecha, se llama automáticamente a descargar_precios_omie
        this.configuracion['fechaActual'] =fecha.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),  
        console.log("Descargar caso base ")
        //El caso base no debería modificar las series temporales de base
        await this.obtener_caso_base() 
        // Forzar reseteo de this.elec_precios_OMIE para que falle si no se llega a descargar datos
 
        this.generarDisponibilidad();
        this.generarAcoplamiento();
        this.actualizarAcoplamiento(this.estadoAcoplamiento);
        
        //this.generarDatosRoCogeneracion(this.configuracion.horizonte);
        this.generarDemandas();
        this.generarManuales();
        this.obtenerRo()
        this.mensaje_loading = "Descargando caso base..." 

        //console.log("OBTENER CASO BASE: ", this.configuracion.fechaActual)
        //LLamar al hijo  
        if (this.vista_operador == false){
          //console.log("Actualizar horizonte en hijo")
          this.$refs.ComponenteConf.actualizarHorizonte(this.configuracion.precios);
        }

        /* this.configuracion.fechaActual=new Date().toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
        this.accionEnCambioFecha(this.configuracion.fechaActual) */
        


            
        this.mensaje_loading = "Descargando precios de OMIE..."
        //No hace falta llamar explicitamente a descargar_omie porque al cambiar la fecha, se llama automáticamente
        //await this.descargar_precios_omie()      
        this.mensaje_loading = "Descargando precios de SimularT..."
        await this.descargar_precios_simulart()
        this.mensaje_loading = "Descargando precios de MIBGAS..."
        await this.descargar_precios_mibgas()
        this.loading = false;

      }
      

    },

  
  watch: {
    demanda_vapor(nuevoValor){
      console.log("DEMANDA VAPOR CAMBIADA: ",nuevoValor[0])
    },
     tab1(nuevoValor) {
    if (nuevoValor === "9" && this.configuracion.modoEjecucion === 4) {
      this.mensaje_loading = "Cargando resultados de planificación...";
      this.loading = true;

      
        setTimeout(() => {
        this.loading = false;
        this.mensaje_loading = "";
      }, 20000); 
      }
    },
  
    elec_peajes: {
      handler(newDatos) {
        console.log("Actualizados peajes con", newDatos);
      },
      deep: true,
    },
    elec_precios_manual: {
      handler(newDatos) {
        console.log("Actualizados precios manuales", newDatos);
      },
      deep: true,
    },
    "configuracion.horizonte": {
      
      handler(nuevoHorizonte,antiguo) {
        if (this.deshabilitar_generacion>0){
          //console.log("horizonte -=1 ", this.deshabilitar_generacion)
          this.deshabilitar_generacion-=1
          return
        }
        console.log("Nuevo horizonte : ", nuevoHorizonte, " Antiguo horizonte: ", antiguo)
        this.actualizar_horizonte_horas()
        this.generarAcoplamiento(); // Se generan nuevos datos
        this.generarDemandas();
        this.generarManuales()
        this.generarDisponibilidad();
        console.log("Nuevo horizonte detectado:", nuevoHorizonte);
      },
      immediate: true
    },
    "configuracion.modoEjecucionTexto": {
      async handler(nuevoModo) {
        if (this.deshabilitar_generacion>0){
          //console.log("modoEjecucionTexto -=1 ", this.deshabilitar_generacion)
          this.deshabilitar_generacion-=1
          return
        }
        console.log("Modo de ejecución:", nuevoModo);

        // Si la simulación se ha cargado desde ID, corrige el valor numérico si es necesario
        if (this.id != null) {
          const modoMapInverso = {
            "Optimización": 0,
            "Sin parar cogeneración": 1,
            "Acoplamientos de cogeneración fijados": 2,
            "Backtesting": 3,
            "Planificación": 4
          };

          const modoNum = modoMapInverso[nuevoModo];
          if (modoNum !== undefined && this.configuracion.modoEjecucion !== modoNum) {
            this.configuracion.modoEjecucion = modoNum;
            console.log(`Corrigiendo modoEjecucion a ${modoNum}`);
          }
        }

        
        if (nuevoModo === "Backtesting") {
          await this.descargar_precios_omie();
          await this.descargar_precios_mibgas();
          await this.generarDatosDemandaHistorico();
          await this.generarDisponibilidadHistorico();
          await this.generarAcoplamientoHistorico();
          //await this.generarDatosRoCogeneracion(this.configuracion.horizonte);
          await this.obtenerRo()
        } else if (nuevoModo === "Planificación") {
          //await this.descargar_precios_omie();
          //await this.descargar_precios_mibgas();
          await this.generarDatosDemandaHistorico();
          await this.generarDisponibilidadPlanificacion();
          await this.generarAcoplamientoHistorico();
          await this.generarPreciosPlanificacion();
          //await this.generarDatosRoCogeneracion(this.configuracion.horizonte);
          await this.obtenerRo()
        } else {
        if(this.id!=null){
          return;
        }
          await this.generarDemandas();
          
          await this.generarDisponibilidad();
          await this.generarAcoplamiento();
          console.log("descargar precios_omie 2" )
          await this.descargar_precios_omie();
          await this.descargar_precios_omie_QH();
          await this.descargar_precios_mibgas();
          //await this.generarDatosRoCogeneracion(this.configuracion.horizonte);
          await this.obtenerRo()
        }
      },
      immediate: true
    },

    "configuracion.fechaActual": {
      handler(nuevaFecha) {
        console.log("📅 Fecha actual cambiada:", nuevaFecha);
        
        this.configuracion.mes = this.obtenerMesAnioDesdeFechaActual();
        
         this.actualizar_horizonte_horas()
      },
      immediate: true
    },  
  /*  'acoplamiento_equipos.cogeneracion': {
  handler(nuevoAcoplamiento) {
    if (this.bloqueoIncompatibilidad) return;

    const hayError = this.verificarIncompatibilidades(this.disponibilidad.cogeneracion, nuevoAcoplamiento, this.estadoAcoplamiento);

    if (hayError) {
      this.bloqueoIncompatibilidad = true;
      this.$nextTick(() => {
        this.acoplamiento_equipos.cogeneracion = JSON.parse(JSON.stringify(this.acoplamientoAnterior));
        this.bloqueoIncompatibilidad = false;
      });
    } else {
      this.acoplamientoAnterior = JSON.parse(JSON.stringify(nuevoAcoplamiento));
    }
  },
  deep: true
},
    'disponibilidad.cogeneracion': {
  handler(nuevaDisponibilidad) {
    if (this.bloqueoIncompatibilidad) return;

    const hayError = this.verificarIncompatibilidades(nuevaDisponibilidad, this.acoplamiento_equipos.cogeneracion, this.estadoAcoplamiento);

    if (hayError) {
      this.bloqueoIncompatibilidad = true;
      this.$nextTick(() => {
        this.disponibilidad.cogeneracion = JSON.parse(JSON.stringify(this.disponibilidadAnterior));
        this.bloqueoIncompatibilidad = false;
      });
    } else {
      this.disponibilidadAnterior = JSON.parse(JSON.stringify(nuevaDisponibilidad));
    }
  },
  deep: true
},

'estadoAcoplamiento': {
  handler(nuevoEstado) {
    if (this.bloqueoIncompatibilidad) return;

    const hayError = this.verificarIncompatibilidades(this.disponibilidad.cogeneracion, this.acoplamiento_equipos.cogeneracion, nuevoEstado);

    if (hayError) {
      this.bloqueoIncompatibilidad = true;
      this.$nextTick(() => {
        this.estadoAcoplamiento = JSON.parse(JSON.stringify(this.estadoAcoplamientoAnterior));
        this.bloqueoIncompatibilidad = false;
      });
    } else {
      this.estadoAcoplamientoAnterior = JSON.parse(JSON.stringify(nuevoEstado));
    }
  },
  deep: true
      
  }*/
  
    },
  };
  </script>
  
  <style scoped>
  .v-tabs--vertical {
  align-items: end;
  flex-direction: column;
}
.v-tabs-slider-wrapper {
  left: auto !important;
  right: 0;
}
  .ml-4 {
    margin-left: 50px;
  }
  .mt-4 {
    margin-top: 50px;
  }
  .custom-container {
      padding-left: 0px; /* Ajusta el padding izquierdo */
      padding-right: 0px; /* Ajusta el padding derecho */
  }
  
  .animated-btn {
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .animated-btn:hover {
    transform: scale(1.1); /* Aumenta ligeramente el tamaño */
    box-shadow: 0px 4px 20px rgba(0, 0, 255, 0.4); /* Sombra azul */
  }
  
  .full-height {
    min-height: calc(100vh - 64px); /* Resta la altura de la barra de navegación */
    height: 100%;
  }
  .fill-height {
    height: 100%;
    min-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
  }
  .v-card-text {
    flex-grow: 1;
    height: 100%;
  }

  
  
  </style>
  